// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
   Options Trading Page CSS
   ============================================================================= */

.agcex-options-wrapper {
  background: #171a20;
  color: #e7e7e7;
  font-family: "Inter", sans-serif;
  min-height: 100vh;
  padding: 7px 8px 8px;
  display: flex;
  flex-direction: column;
}

body.light_theme .agcex-options-wrapper {
  background: #f8f9fa;
  color: #0b0e11;
}

.agcex-options-wrapper .trade_summary_table_lft_position_order.position_order {
  border-radius: 8px;
}

/* --- Tickers Bar --- */
.options-tickers-bar {
  display: flex;
  align-items: center;
  padding: 12px 24px;
  border-bottom: none;
  gap: 24px;
  background-color: #fff;
  border-radius: 8px;
  scrollbar-width: none;
}

body.dark_theme .options-tickers-bar {
  border-bottom-color: #2b3139;
}

.options-tickers-bar::-webkit-scrollbar {
  display: none;
}

.options-ticker-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: background 0.2s;
  white-space: nowrap;
}


.options-ticker-item.active {
  background: #f4f5f614;
}

body.light_theme .options-ticker-item.active {
  background: #e2e8f0;
}

.options-ticker-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: contain;
}

.options-ticker-info {
  display: flex;
  flex-direction: column;
}

.options-ticker-symbol {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

body.dark_theme .options-ticker-symbol {
  color: #eaecef;
}

.options-ticker-price {
  font-size: 12px;
  font-weight: 500;
}

.text-green {
  color: #02c076 !important;
}

.text-danger {
  color: #f84960 !important;
}

.text-muted {
  color: #848e9c !important;
}

/* --- AI Expiration Row --- */
.options-ai-row {
  display: flex;
  align-items: center;
  padding: 16px 24px 8px;
  gap: 16px;
  background: #ffffff0f;
  margin: 0px 0px;
  border-radius: 8px 8px 0px 0px;
  position: relative;
}

body.light_theme .options-ai-row {
  background-color: #fff;
}

.options-dates-scroll {
  display: flex;
  align-items: center;
  gap: 16px;
  overflow-x: auto;
  white-space: nowrap;
  flex: 1 1;
  scrollbar-width: none;
  min-width: 0;
}

.options-dates-scroll::-webkit-scrollbar {
  display: none;
}

.options-dates-scroll-arrow {
  background: none;
  border: none;
  font-size: 18px;
  color: #848e9c;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 0px;
  flex-shrink: 0;
  transition: all 0.2s;
  padding: 0;
}

.options-dates-scroll-arrow:hover {
  color: #1e2329;
}

body.dark_theme .options-dates-scroll-arrow:hover {
  color: #eaecef;
}

.options-ai-btn {
  background-color: #34363c;
  color: #eaecef;
  border: none;
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s, color 0.2s;
}

body.light_theme .options-ai-btn {
  color: #474d57;
  background-color: #f2f3f4;
}

.options-date-btn {
  background: transparent;
  border: none;
  font-size: 12px;
  font-weight: 500;
  color: #eaecef;
  padding: 3px 10px;
  background-color: #34363c;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s, color 0.2s;
}

body.light_theme .options-date-btn {
  color: #474d57;
  background-color: #f2f3f4;
}

.options-ai-btn.active,
.options-date-btn.active {
  background: #1e2329;
  color: #fff;
}

body.light_theme .options-ai-btn.active,
body.light_theme .options-date-btn.active {
  background: #1e2329;
  color: #fff;
}

body.dark_theme .options-date-btn:hover:not(.active),
body.dark_theme .options-ai-btn:hover:not(.active) {
  background: #2b3139;
}

body.light_theme .options-date-btn:hover:not(.active),
body.light_theme .options-ai-btn:hover:not(.active) {
  background: #e8eaed;
}

/* --- Filter Row --- */
.options-filter-row {
  display: flex;
  align-items: center;
  padding: 8px 24px 16px;
  gap: 16px;
  background: #26292f;
  border-radius: 0px 0px 8px 8px;
  margin-bottom: 4px;
  position: relative;
}

body.light_theme .options-filter-row {
  background-color: #ffffff;
}

.options-filters-scroll {
  display: flex;
  align-items: center;
  gap: 16px;
  overflow-x: auto;
  white-space: nowrap;
  flex: 1 1;
  scrollbar-width: none;
  min-width: 0;
}

.options-filters-scroll::-webkit-scrollbar {
  display: none;
}

.options-filters-scroll>* {
  flex-shrink: 0 !important;
}

.options-filters-scroll-arrow {
  background: none;
  border: none;
  font-size: 18px;
  color: #848e9c;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 0px;
  flex-shrink: 0;
  transition: all 0.2s;
  padding: 0;
}

.options-filters-scroll-arrow:hover {
  color: #1e2329;
}

body.dark_theme .options-filters-scroll-arrow:hover {
  color: #eaecef;
}

.options-global-header {
  background: #f8f9fa !important;
}

.options-filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #d1d1d1;
  font-weight: 500;
}

body.light_theme .options-filter-group {
  color: #474d57;
}

.options-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.options-input,
.options-select {
  border: 1px solid #e2e8f00f;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  color: #ffffff;
  background: #34363c;
  outline: none;
}

body.light_theme .options-input,
body.light_theme .options-select {
  border-color: #e2e8f0;
  background: #fff;
  color: #0f172a;

}

.options-reset-btn {
  background: transparent;
  border: none;
  color: #848e9c;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

.options-position-builder-btn {
  margin-left: auto;
  background: #2b3139;
  color: #fff;
  border: none;
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}

.options-position-builder-btn i {
  font-size: 16px;
}

/* --- Table Layout Redesign --- */
.options-table-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 580px;
  max-height: 580px;
  min-height: 580px;
  border-radius: 8px;
}

.options-panels-wrapper {
  display: flex;
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
}

body.dark_theme .options-panels-wrapper {
  border-top-color: #2b3139;
}

.options-panel {
  display: flex;
  flex-direction: column;
}

.options-panel-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #f8f9fa;
}

body.dark_theme .options-panel-header {
  background: #0b0e11;
}

.calls-panel,
.puts-panel {
  flex: 1 1;
  overflow-x: auto;
  overflow-y: visible;
  background: #26292f;
}

body.light_theme .calls-panel,
body.light_theme .puts-panel {
  background: #fff;
}

.calls-panel::-webkit-scrollbar,
.puts-panel::-webkit-scrollbar {
  height: 6px;
}

.calls-panel::-webkit-scrollbar-thumb,
.puts-panel::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 3px;
}

body.dark_theme .calls-panel::-webkit-scrollbar-thumb,
body.dark_theme .puts-panel::-webkit-scrollbar-thumb {
  background: #2b3139;
}

.strike-panel {
  width: 120px;
  flex-shrink: 0;
  border-left: 1px solid #e2e8f04f;
  border-right: 1px solid #e2e8f054;
  background: #26292f;
  z-index: 11;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.02);
}

body.light_theme .strike-panel {
  border-left: 1px solid #e2e8f0;
  border-right: 1px solid #e2e8f0;
  background: #fafafa;
}

.options-panel-inner {
  display: flex;
  flex-direction: column;
  width: max-content;
  min-width: 100%;
}

.calls-panel .options-sub-headers,
.calls-panel .options-panel-row {
  justify-content: space-between;
}

.puts-panel .options-sub-headers,
.puts-panel .options-panel-row {
  justify-content: space-between;
}

/* Row synchronization */
.options-panel-row {
  display: flex;
  height: 48px;
  border-bottom: 1px solid #f1f5f92b;
  background: #26292f;

}

body.light_theme .options-panel-row {
  border-bottom: 1px solid #f1f5f9;
  background: #fff;
}

.options-panel-row:hover {
  background: #f1f5f921;
}

body.light_theme .options-panel-row:hover {
  background: #f1f5f9;
}

.options-panel-row.itm {
  background: rgb(38 41 47);
}

body.light_theme .options-panel-row.itm {
  background: rgba(2, 192, 118, 0.05);
}

.options-strike-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 48px;
  border-color: #2b3139;
  color: #eaecef;
  background: #26292f;
  font-weight: 500;
  font-size: 13px;

}

body.light_theme .options-strike-cell {
  border-bottom: 1px solid #f1f5f9;
  color: #1e2329;
  background: #fafafa;
}

.options-group-header-strike {
  background: rgb(38 41 47) !important;
  border-bottom: 1px solid rgba(226, 232, 240, 0.295) !important;
  border-top: 1px solid rgba(226, 232, 240, 0.432) !important;
}

body.light_theme .options-group-header-strike {

  background: rgb(248, 249, 250) !important;
  border-bottom: 1px solid rgb(226, 232, 240);
  border-top: 1px solid rgb(226, 232, 240);
}

.options-strike-sub {
  font-size: 11px;
  color: #848e9c;
  font-weight: 400;
}

/* Headers */
.options-panel-header-top {
  display: flex;
  align-items: center;
  height: 44px;
  background: #fafafa;
  border-bottom: 1px solid #e2e8f0;
  font-size: 14px;
  font-weight: 600;
  color: #1e2329;
}

body.dark_theme .options-panel-header-top {
  background: #1e2329;
  color: #eaecef;
  border-bottom-color: #2b3139;
}

.options-sub-headers {
  display: flex;
  align-items: center;
  height: 36px;
  border-bottom: none;
  background: #26292f;
}

body.light_theme .options-sub-headers {
  background: #fcfcfc;
}

.agcex-opt-group-header {
  padding: 8px 0;
  background: #26292f;
  border-bottom: 1px solid #e2e8f04a;
  border-top: 1px solid #e2e8f033;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

body.light_theme .agcex-opt-group-header {
  background: #f8f9fa;
  border-bottom: 1px solid #e2e8f0;
  border-top: 1px solid #e2e8f0;
}

.agcex-opt-group-title {
  position: sticky;
  font-weight: bold;
  z-index: 5;
}

.agcex-opt-group-title.left {
  left: 16px;
}

.agcex-opt-group-title.right {
  right: 16px;
}

.agcex-opt-group-info {
  position: sticky;
  color: #848e9c;
  z-index: 5;
}

.agcex-opt-group-info.left {
  left: 16px;
}

.agcex-opt-group-info.right {
  right: 16px;
}

.agcex-opt-group-divider {
  margin: 0 8px;
}

body.dark_theme .options-sub-headers {
  border-bottom-color: #2b3139;
  background: #0b0e11;
}

.options-sub-header-cell {
  flex: none;
  padding: 0 4px;
  width: 70px;
  font-size: 12px;
  font-weight: 600;
  color: #dedede;
  text-align: left;
  white-space: nowrap;
}

body.light_theme .options-sub-header-cell {
  color: #080808;
}

.options-sub-header-cell:first-child {
  padding-left: 16px;
}

.options-sub-header-cell:last-child {
  padding-right: 16px;
}

body.dark_theme .options-sub-header-cell {
  color: #848e9c;
}

/* Cells */
.options-cell {
  flex: none;
  width: 70px;
  padding: 0 4px;
  font-size: 13px;
  color: #dfdfdf;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  cursor: pointer;
}

body.light_theme .options-cell {
  color: #1e2329;
}

.options-cell:first-child {
  padding-left: 16px;
}

.options-cell:last-child {
  padding-right: 16px;
}

body.dark_theme .options-cell {
  color: #eaecef;
}

.options-cell.bid-ask:hover {
  background: rgba(132, 142, 156, 0.1);
}

.options-cell-sub {
  font-size: 11px;
  color: #848e9c;
  margin-top: 2px;
}

.fw-500 {
  font-weight: 500 !important;
}

/* Forward Line in panels */
.options-forward-line-half {
  height: 24px;
  display: flex;
  align-items: center;
  position: relative;
}

.options-forward-line-left,
.options-forward-line-right {
  height: 1px;
  background: #e2e8f0;
  width: 100%;
}

body.dark_theme .options-forward-line-left,
body.dark_theme .options-forward-line-right {
  background: #2b3139;
}

.options-forward-label {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1e2329;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  height: 20px;
  margin: 0 auto;
}

body.dark_theme .options-forward-label {
  background: #eaecef;
  color: #1e2329;
}

/* --- Order Sidebar Modal --- */
.options-order-sidebar {
  position: fixed;
  top: 0;
  right: -400px;
  width: 360px;
  height: 100vh;
  background: #fff;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.1);
  z-index: 10500;
  transition: right 0.3s ease;
  display: flex;
  flex-direction: column;
}

body.dark_theme .options-order-sidebar {
  background: #1e2329;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.5);
}

.options-order-sidebar.open {
  right: 0;
}

.options-order-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
}

body.dark_theme .options-order-header {
  border-bottom-color: #2b3139;
}

.options-order-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e2329;
}

body.dark_theme .options-order-title {
  color: #eaecef;
}

.options-order-close {
  background: transparent;
  border: none;
  font-size: 20px;
  color: #848e9c;
  cursor: pointer;
}

.options-order-close:hover {
  color: #1e2329;
}

body.dark_theme .options-order-close:hover {
  color: #eaecef;
}

.options-order-body {
  padding: 20px;
  flex: 1 1;
  overflow-y: auto;
}

.options-order-toggle {
  display: flex;
  background: #f1f5f9;
  border-radius: 6px;
  padding: 2px;
  margin-bottom: 16px;
}

body.dark_theme .options-order-toggle {
  background: #0b0e11;
}

.options-order-toggle-btn {
  flex: 1 1;
  background: transparent;
  border: none;
  padding: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #848e9c;
  cursor: pointer;
  border-radius: 4px;
}

.options-order-toggle-btn.buy.active {
  background: #02c076;
  color: #fff;
}

.options-order-toggle-btn.sell.active {
  background: #f84960;
  color: #fff;
}

.options-order-field {
  margin-bottom: 16px;
}

.options-order-label {
  display: block;
  font-size: 13px;
  color: #474d57;
  margin-bottom: 6px;
  font-weight: 500;
}

body.dark_theme .options-order-label {
  color: #848e9c;
}

.options-order-input-wrapper {
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 0 12px;
}

body.dark_theme .options-order-input-wrapper {
  background: #0b0e11;
  border-color: #2b3139;
}

.options-order-input {
  flex: 1 1;
  background: transparent;
  border: none;
  padding: 10px 0;
  font-size: 14px;
  color: #1e2329;
  outline: none;
}

body.dark_theme .options-order-input {
  color: #eaecef;
}

.options-order-suffix {
  font-size: 13px;
  color: #848e9c;
}

.options-order-summary {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px dashed #e2e8f0;
}

body.dark_theme .options-order-summary {
  border-top-color: #2b3139;
}

.options-order-summary-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  margin-bottom: 8px;
}

.options-order-summary-label {
  color: #848e9c;
}

.options-order-summary-val {
  color: #1e2329;
  font-weight: 600;
}

body.dark_theme .options-order-summary-val {
  color: #eaecef;
}

.options-place-btn {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  margin-top: 24px;
  transition: opacity 0.2s;
}

.options-place-btn.buy {
  background: #02c076;
}

.options-place-btn.sell {
  background: #f84960;
}

.options-place-btn:hover {
  opacity: 0.9;
}

/* Backdrop */
.options-sidebar-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10400;
  display: none;
}

.options-sidebar-backdrop.show {
  display: block;
}

/* --- Recent Trades 24h Vol --- */
.options-recent-trades-container {
  display: flex;
  gap: 4px;
  padding: 4px 0px;
  background: #26292f
}

body.light_theme .options-recent-trades-container {
  background: #f8f9fa;
}

.options-recent-trades-panel {
  flex: 1 1;
  background: #171a20;
  border: none;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}

body.light_theme .options-recent-trades-panel {
  background: #fff;
  border-color: #2b3139;
}

.options-recent-trades-header {
  padding: 12px 16px;
  border-bottom: 1px solid #f3f3f31c;
  font-weight: 600;
  font-size: 14px;
  color: #eaecef;
  display: flex;
  align-items: baseline;
  gap: 12px;
}

body.light_theme .options-recent-trades-header {
  border-bottom-color: #f3f3f3;

  color: #1e2329;
}

.options-recent-trades-vol {
  font-size: 12px;
  color: #848e9c;
  font-weight: 400;
}

.options-recent-trades-body-wrap {
  max-height: 250px;
  overflow-y: auto;
}

.options-recent-trades-body-wrap::-webkit-scrollbar {
  width: 6px;
}

.options-recent-trades-body-wrap::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 3px;
}

body.dark_theme .options-recent-trades-body-wrap::-webkit-scrollbar-thumb {
  background: #2b3139;
}

.options-recent-trades-table {
  width: 100%;
  border-collapse: collapse;
}

.options-recent-trades-table th {
  position: sticky;
  top: 0;
  background: #171a20;
  z-index: 2;
  padding: 8px 16px;
  text-align: right;
  font-size: 12px;
  color: #848e9c;
  font-weight: 500;
  border-bottom: 1px solid #f3f3f31c;
  white-space: nowrap;
}

body.light_theme .options-recent-trades-table th {
  background: #fff;
  border-bottom: 1px solid #f3f3f3;
}

.options-recent-trades-table th:first-child,
.options-recent-trades-table td:first-child {
  text-align: left;
}

.options-recent-trades-table td {
  padding: 12px 16px;
  text-align: right;
  font-size: 12px;
  color: #d9d9d9;
  border-bottom: none;
  font-weight: 500;
  white-space: nowrap;
}

body.light_theme .options-recent-trades-table td {
  color: #1e2329;
  border-bottom-color: #1e2329;
}

/* --- Options Column Toggle Menu --- */
.agcex-options-col-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 160px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: #1e2329;
  text-align: left;
}

body.dark_theme .agcex-options-col-menu {
  background: #1e2329;
  border-color: #2b3139;
  color: #eaecef;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
}

.agcex-options-col-menu-item {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
}

.agcex-options-col-menu-icon {
  font-size: 16px;
  color: #d2d6de;
}

body.dark_theme .agcex-options-col-menu-icon {
  color: #474d57;
}

.agcex-options-col-menu-icon.checked {
  color: #333b46;
}

body.dark_theme .agcex-options-col-menu-icon.checked {
  color: #eaecef;
}

.mid_lft_option {
  min-width: 100%;
  position: relative;
}

.mid_option_s.d-flex {
  gap: 4px;
  margin-top: 4px;
}

.mid_right_option {
  display: none;
  background-color: #26292fd6;
  width: 28%;
  border-radius: 8px;
  flex-direction: column;
}

.mid_right_option.is-open {
  display: flex;
}

body.light_theme .mid_right_option {
  background-color: #ffffff;
}

.option-account-sidebar-rail {
  width: 100%;
  flex-shrink: 0;
  border-top: 1px solid #2b3139;
  background: #181a20;
  border-radius: 0 0 8px 8px;
}

body.light_theme .option-account-sidebar-rail {
  border-top-color: #eaecef;
  background: #fff;
}

.trade_account_summary_assets.trade-panel-open .trade_summary_table_lft {
  flex: 1 1;
  min-width: 0;
  width: 100%;
}

.assets_right.assets_panel_desktop.option_assetsright {
  min-width: 19%;
  max-width: 19%;
  flex-shrink: 0;
}

/* --- New Sidebar Header --- */
.agcex-new-sidebar-header {
  padding: 16px;
}

body.dark_theme .agcex-new-sidebar-header {
  background: #26292f26;
  border-left-color: #2b3139;
}

.agcex-nsh-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.agcex-nsh-title-area {
  display: flex;
  align-items: center;
  gap: 8px;
}

.agcex-nsh-title {
  font-size: 16px;
  font-weight: 600;
  color: #eaecef;
}

body.light_theme .agcex-nsh-title {
  color: #1e2329;
}

.agcex-nsh-info {
  color: #848e9c;
  font-size: 16px;
  cursor: pointer;
}

.agcex-nsh-collapse {
  color: #848e9c;
  cursor: pointer;
  font-size: 18px;
}

.agcex-nsh-stats {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-top: 1px solid #f0f0f0;
  padding-top: 12px;
  overflow-x: auto;
  gap: 15px;
}

.agcex-nsh-stats::-webkit-scrollbar {
  display: none;
}

body.dark_theme .agcex-nsh-stats {
  border-top-color: #2b3139;
}

.agcex-nsh-stat-col {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 0 0 auto;
}

.agcex-nsh-stat-label {
  color: #848e9c;
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.agcex-nsh-stat-label .dotted-underline {
  border-bottom: 1px dashed #848e9c;
}

.agcex-nsh-stat-val {
  font-size: 13px;
  font-weight: 600;
  color: #eaecef;
}

body.light_theme .agcex-nsh-stat-val {
  color: #1e2329;
}

/* --- Options Orderbook & Form Layout --- */
.agcex-options-trade-center {
  display: flex;
  width: 100%;
}

.agcex-opt-orderbook {
  width: 100%;
  flex: 1 1;
  padding: 12px 8px;
  background: #26292f26;
}

.agcex-opt-orderform {
  width: 100%;
  flex: 1 1;
  padding: 12px;
  background: #26292f26;
}

body.light_theme .agcex-opt-orderbook {
  background: #ffffff17;
}


body.light_theme .agcex-opt-orderform {
  background: #fff;
}

/* Orderbook styles mock */
.agcex-opt-ob-filters {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  padding: 0 4px;
}

.agcex-opt-ob-filter-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.agcex-opt-ob-table {
  width: 100%;
  font-size: 12px;
  border-collapse: collapse;
  border-spacing: 0;
}

.agcex-opt-ob-table tr {
  height: 22px;
}

.agcex-opt-ob-table th {
  color: #848e9c;
  font-weight: normal;
  padding: 4px;
  text-align: right;
}

.agcex-opt-ob-table th:first-child {
  text-align: left;
}

.agcex-opt-ob-table td {
  padding: 2px 4px;
  text-align: right;
}

.agcex-opt-ob-table td:first-child {
  text-align: left;
}

.agcex-opt-ob-price-red {
  color: #f6465d;
}

.agcex-opt-ob-price-green {
  color: #0ecb81;
}

.agcex-opt-ob-mid {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  margin: 8px 0;
}

.agcex-opt-ob-bar-wrap {
  display: flex;
  height: 4px;
  width: 100%;
  margin-top: 4px;
  border-radius: 2px;
  overflow: hidden;
}

.agcex-opt-ob-bar-green {
  background-color: #0ecb81;
  flex: 1 1;
}

.agcex-opt-ob-bar-red {
  background-color: #f6465d;
  flex: 1 1;
}

/* Order Form styles mock */
.agcex-opt-form-tabs {
  display: flex;
  background: #F6F6F7;
  border-radius: 4px;
  margin-bottom: 12px;
  overflow: hidden;
}

body.dark_theme .agcex-opt-form-tabs {
  background: #2b3139;
}

.agcex-opt-form-tab {
  flex: 1 1;
  text-align: center;
  cursor: pointer;
  color: #848e9c;
  font-weight: 400;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 13px;
}

.agcex-opt-form-tab.buy.active {
  background: #0ecb81;
  color: #fff;
}

.agcex-opt-form-tab.sell.active {
  background: #f6465d;
  color: #fff;
}

.agcex-opt-form-subtabs {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #848e9c;
}

.agcex-opt-form-subtab {
  cursor: pointer;
  position: relative;
  margin: 5px 0px;
  padding-bottom: 8px;
}

.agcex-opt-form-subtab.active {
  color: #1e2329;
  font-weight: 600;
}

.agcex-opt-form-subtab.active::after {
  position: absolute;
  content: " ";
  min-width: 30px;
  height: 3px;
  border-radius: 10px;
  background-color: #d1aa67;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%) scaleX(.5);
  /* opacity: 0; */
  transition: all .16s ease-in;
}

body.dark_theme .agcex-opt-form-subtab.active {
  color: #eaecef;
}

.agcex-opt-input-group {
  margin-bottom: 12px;
}

.agcex-opt-input-label {
  font-size: 12px;
  color: #848e9c;
  margin-bottom: 4px;
}

.agcex-opt-input-wrap {
  display: flex;
  align-items: center;
  background: #f5f5f512;
  border-radius: 4px;
  padding: 0 12px;
  height: 40px;
  border: 1px solid transparent;
  transition: border-color 0.15s ease;
}

body.light_theme .agcex-opt-input-wrap {
  background: #f5f5f5;
}

.agcex-opt-input-wrap--error {
  border-color: #f6465d;
  background: #ffffff12;
}

body.light_theme .agcex-opt-input-wrap--error {
  border-color: #f6465d;
  background: #fff;
}

.agcex-opt-price-band-msg {
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.35;
  color: #f6465d;
}

.agcex-opt-form-error-msg {
  margin: 0 0 10px;
  font-size: 12px;
  line-height: 1.35;
  color: #f6465d;
}

.agcex-opt-submit-btn.is-disabled,
.agcex-opt-submit-btn:disabled {
  background-color: #d0d4db !important;
  color: #fff;
  cursor: not-allowed;
  opacity: 1;
}

body.dark_theme .agcex-opt-submit-btn.is-disabled,
body.dark_theme .agcex-opt-submit-btn:disabled {
  background-color: #474d57 !important;
  color: #848e9c;
}

body.dark_theme .agcex-opt-input-wrap {
  background: #2b3139;
}

.agcex-opt-input-wrap input {
  flex: 1 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
  color: #eaecef;
}

body.light_theme .agcex-opt-input-wrap input {
  color: #1e2329;
}

.agcex-opt-input-addon {
  font-size: 13px;
  color: #eaecef;
  font-weight: 500;
}

body.light_theme .agcex-opt-input-addon {
  color: #1e2329;
}

.agcex-opt-transfer-icon--gold {
  color: #d1aa67;
}

.agcex-opt-field-hint {
  margin-left: 6px;
  font-size: 11px;
  color: #b7bdc6;
  font-weight: 400;
}

.agcex-opt-avbl-row {
  margin-bottom: 16px;
}

.agcex-opt-label-info {
  font-size: 12px;
  color: #848e9c;
  vertical-align: middle;
}

.agcex-opt-iv-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #848e9c;
  margin-bottom: 12px;
}

.agcex-opt-iv-row-val {
  color: #eaecef;
  font-weight: 500;
  font-size: 13px;
}

body.light_theme .agcex-opt-iv-row-val {
  color: #1e2329;
}

.agcex-opt-input-wrap--amount input::placeholder {
  color: #b7bdc6;
  font-size: 13px;
}

.agcex-opt-pct-slider {
  position: relative;
  margin: 16px 0 20px;
  padding: 0 2px;
}

.agcex-opt-pct-slider-track {
  height: 2px;
  background: #eaecef;
  border-radius: 1px;
}

body.dark_theme .agcex-opt-pct-slider-track {
  background: #2b3139;
}

.agcex-opt-pct-slider-ticks {
  display: flex;
  justify-content: space-between;
  margin-top: -6px;
}

.agcex-opt-pct-tick {
  width: 10px;
  height: 10px;
  padding: 0;
  border: 2px solid #eaecef;
  background: #fff;
  transform: rotate(45deg);
  cursor: pointer;
}

body.dark_theme .agcex-opt-pct-tick {
  background: #181a20;
  border-color: #474d57;
}

.agcex-opt-pct-tick.is-active {
  border-color: #1e2329;
  background: #fff;
}

body.dark_theme .agcex-opt-pct-tick.is-active {
  border-color: #eaecef;
  background: #181a20;
}

.agcex-opt-tif-row,
.agcex-opt-reduce-tif-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  color: #848e9c;
  margin-bottom: 16px;
}

.agcex-opt-reduce-only {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  cursor: pointer;
}

.agcex-opt-reduce-only.is-locked {
  cursor: default;
  opacity: 0.9;
}

.agcex-opt-reduce-only.is-locked input {
  cursor: not-allowed;
}

.agcex-opt-reduce-only-label {
  border-bottom: 1px dotted #848e9c;
}

.agcex-opt-reduce-only input {
  width: 14px;
  height: 14px;
  margin: 0;
  accent-color: #1e2329;
}

.agcex-opt-tif-select {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  cursor: pointer;
  position: relative;
}

.agcex-opt-tif-value {
  display: flex;
  align-items: center;
  color: #eaecef;
  font-size: 13px;
  font-weight: 500;
  padding-right: 14px;
  cursor: pointer;
}

body.light_theme .agcex-opt-tif-value {
  color: #1e2329;
}

.agcex-opt-tif-options {
  position: absolute;
  top: 100%;
  right: 0;
  margin: 0;
  padding: 4px 0;
  list-style: none;
  background: #2b3139;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  z-index: 10;
  min-width: 70px;
}

body.light_theme .agcex-opt-tif-options {
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.agcex-opt-tif-options li {
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  color: #eaecef;
  cursor: pointer;
  transition: background 0.2s;
  text-align: left;
}

body.light_theme .agcex-opt-tif-options li {
  color: #1e2329;
}

.agcex-opt-tif-options li:hover,
.agcex-opt-tif-options li.active {
  background: #363c45;
}

body.light_theme .agcex-opt-tif-options li:hover,
body.light_theme .agcex-opt-tif-options li.active {
  background: #f3f4f6;
}

.agcex-opt-tif-select i {
  position: absolute;
  right: 0;
  pointer-events: none;
  font-size: 14px;
  color: #848e9c;
  transition: transform 0.2s;
}

.agcex-opt-tif-select i.open {
  transform: rotate(180deg);
}

.agcex-opt-form-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #848e9c;
}

.agcex-opt-fee-rate-wrap {
  position: relative;
}

.agcex-opt-fee-rate {
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  border-bottom: 1px dashed #848e9c;
  cursor: pointer;
  color: #848e9c;
}

.agcex-opt-fee-tooltip {
  position: absolute;
  right: 0;
  bottom: calc(100% + 8px);
  z-index: 30;
  min-width: 240px;
  padding: 12px 14px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

body:not(.light_theme) .agcex-opt-fee-tooltip {
  background: #1e2329;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.45);
}

.agcex-opt-fee-tooltip-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e2329;
  margin-bottom: 10px;
}

body:not(.light_theme) .agcex-opt-fee-tooltip-title {
  color: #eaecef;
}

.agcex-opt-fee-tooltip-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 12px;
  color: #848e9c;
  line-height: 1.5;
}

.agcex-opt-fee-tooltip-row+.agcex-opt-fee-tooltip-row {
  margin-top: 6px;
}

.agcex-opt-fee-tooltip-row span:last-child {
  color: #1e2329;
  font-weight: 500;
  white-space: nowrap;
}

body:not(.light_theme) .agcex-opt-fee-tooltip-row span:last-child {
  color: #eaecef;
}

.agcex-opt-btn {
  width: 100%;
  background: #0ecb81;
  color: #fff;
  border: none;
  border-radius: 50px !important;
  padding: 11px 22px;
  font-weight: 600;
  font-size: 14px;
  margin-top: 8px;
}

/* --- Inline Extraction for Orderbook --- */
.agcex-opt-ob-filter-icon {
  cursor: pointer;
  padding-bottom: 2px;
}

.agcex-opt-ob-filter-icon svg {
  opacity: 0.4;
  transition: opacity 0.2s ease;
}

.agcex-opt-ob-filter-icon.active svg {
  opacity: 1;
}

.agcex-opt-ob-scroll-250 {
  height: 220px;
  overflow-y: auto;
  overflow-x: hidden;
}

.agcex-opt-ob-scroll-125 {
  height: 110px;
  overflow-y: auto;
  overflow-x: hidden;
}

.agcex-opt-w-100 {
  width: 100%;
}

.agcex-opt-w-25 {
  width: 25%;
}

.agcex-text-left {
  text-align: left;
}

.agcex-text-right {
  text-align: right;
}

.agcex-text-center {
  text-align: center;
}

.agcex-bg-red-light {
  background: rgba(246, 70, 93, 0.1);
}

.agcex-bg-green-light {
  background: rgba(14, 203, 129, 0.1);
}

.agcex-opt-ob-mid {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 4px;
}

.agcex-opt-ob-mid-empty {
  color: #1e2329;
  font-weight: bold;
  font-size: 14px;
}

body.dark_theme .agcex-opt-ob-mid-empty {
  color: #eaecef;
}

.agcex-opt-ob-mid-price {
  color: #d1aa67;
  font-weight: 500;
  font-size: 13px;
  text-decoration: underline;
  display: inline-block;
  line-height: 1.2;
  margin-bottom: 2px;
}

.agcex-opt-ob-mid-iv {
  color: #848e9c;
  font-size: 10px;
  text-align: right;
  line-height: 1;
}

.agcex-opt-ob-bar-flex-0 {
  flex: 0 1;
}

.agcex-opt-ob-bar-flex-1 {
  flex: 1 1;
}

.agcex-opt-ob-bar-divider {
  width: 2px;
  background: #fff;
}

body.dark_theme .agcex-opt-ob-bar-divider {
  background: #1e2329;
}

.agcex-opt-ob-stats {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 4px;
}

.agcex-opt-trades-header {
  font-weight: 600;
  font-size: 14px;
  margin: 16px 0 8px 0;
}

/* --- Contract Unit Modal --- */
.agcex-opt-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgb(255 255 255 / 20%);
  z-index: 9999999999;
}

.agcex-opt-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  width: 530px;
  max-width: 100%;
  border-radius: 12px;
  z-index: 99999999999;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

body.dark_theme .agcex-opt-modal {
  background: #1e2329;
}

.agcex-opt-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 16px;
}

.agcex-opt-modal-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e2329;
}

body.dark_theme .agcex-opt-modal-title {
  color: #eaecef;
}

.agcex-opt-modal-close {
  font-size: 24px;
  color: #848e9c;
  cursor: pointer;
}

.agcex-opt-modal-close:hover {
  color: #1e2329;
}

body.dark_theme .agcex-opt-modal-close:hover {
  color: #eaecef;
}

.agcex-opt-modal-body {
  padding: 0 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.agcex-opt-modal-option {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s;
}

body.dark_theme .agcex-opt-modal-option {
  border-color: #2b3139;
}

.agcex-opt-modal-option.active {
  border-color: #1e2329;
}

body.dark_theme .agcex-opt-modal-option.active {
  border-color: #fcd535;
}

.agcex-opt-modal-option-title {
  font-size: 15px;
  font-weight: 500;
  color: #1e2329;
  margin-bottom: 4px;
}

body.dark_theme .agcex-opt-modal-option-title {
  color: #eaecef;
}

.agcex-opt-modal-option-desc {
  font-size: 13px;
  color: #848e9c;
}

.agcex-opt-modal-footer {
  padding: 0 24px 24px;
}

.agcex-opt-modal-btn {
  width: 100%;
  background: #1e2329;
  color: #fff;
  border: none;
  padding: 12px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

body.dark_theme .agcex-opt-modal-btn {
  background: #fcd535;
  color: #1e2329;
}

.agcex-opt-modal-btn.disabled {
  color: #b7bdc6;
  background: #f8f9fa;
  cursor: not-allowed;
}

body.dark_theme .agcex-opt-modal-btn.disabled {
  background: #2b3139;
  color: #474d57;
}

/* --- Options Chart Tabs (PnL, Mark, Index) --- */
.agcex-opt-chart-tabs-container {
  margin-top: 16px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

body.dark_theme .agcex-opt-chart-tabs-container {
  background: #1e2329;
  border-color: #2b3139;
}

.agcex-opt-chart-tabs-header {
  display: flex;
  flex-wrap: nowrap;
  border-bottom: 1px solid #e2e8f0;
  padding: 0 16px;
  overflow-x: auto;
  white-space: nowrap;
}

body.dark_theme .agcex-opt-chart-tabs-header {
  border-color: #2b3139;
}

.agcex-opt-chart-tab {
  padding: 12px 0;
  margin-right: 16px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #848e9c;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
  flex-shrink: 0;
  position: relative;
}

.agcex-opt-chart-tab.active::after {
  position: absolute;
  content: " ";
  min-width: 40px;
  height: 3px;
  border-radius: 10px;
  background-color: #d1aa67;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%) scaleX(.5);
  /* opacity: 0; */
  transition: all .16s ease-in;
}

.agcex-opt-chart-tab.active {
  font-weight: 600;
  color: #1e2329;
}

body.dark_theme .agcex-opt-chart-tab.active {
  color: #eaecef;
  border-bottom-color: #fcd535;
}

.agcex-opt-chart-refresh {
  display: flex;
  align-items: center;
  color: #848e9c;
  cursor: pointer;
}

.agcex-opt-chart-refresh:hover {
  color: #1e2329;
}

body.dark_theme .agcex-opt-chart-refresh:hover {
  color: #eaecef;
}

.agcex-opt-chart-body {
  padding: 16px;
  min-height: 340px;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

/* PNL specific */
.agcex-opt-chart-pnl-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 8px;
}

.agcex-opt-chart-pnl-legend {
  display: flex;
  gap: 16px;
  align-items: center;
  font-size: 13px;
  color: #1e2329;
}

body.dark_theme .agcex-opt-chart-pnl-legend {
  color: #eaecef;
}

.agcex-opt-chart-pnl-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.agcex-opt-chart-pnl-controls {
  display: flex;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 2px;
}

body.dark_theme .agcex-opt-chart-pnl-controls {
  background: #2b3139;
}

.agcex-opt-chart-pnl-iv {
  padding: 2px 8px;
  font-size: 12px;
  color: #1e2329;
  border-right: 1px solid #d9d9d9;
  cursor: pointer;
  text-decoration: underline;
}

body.dark_theme .agcex-opt-chart-pnl-iv {
  color: #eaecef;
  border-bottom-color: #eaecef;
}

.agcex-opt-chart-pnl-mark {
  padding: 2px 8px;
  font-size: 12px;
  color: #1e2329;
  /* background: #fff; */
  /* border-radius: 2px; */
  /* box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05); */
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}

body.dark_theme .agcex-opt-chart-pnl-mark {
  background: #1e2329;
  color: #eaecef;
}

.agcex-opt-chart-pnl-slider-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.agcex-opt-chart-pnl-badge {
  background: #f5f5f5;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  color: #848e9c;
}

body.dark_theme .agcex-opt-chart-pnl-badge {
  background: #2b3139;
}

.agcex-opt-chart-pnl-slider {
  flex: 1 1;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #1e2329;
}

body.dark_theme .agcex-opt-chart-pnl-slider {
  color: #eaecef;
}

.agcex-opt-chart-pnl-graph {
  flex: 1 1;
  position: relative;
  min-height: 220px;
  margin-left: 32px;
  margin-bottom: 24px;
  border-left: 1px dashed #e2e8f0;
  border-bottom: 1px dashed #e2e8f0;
  display: flex;
  align-items: flex-end;
}

body.dark_theme .agcex-opt-chart-pnl-graph {
  border-color: #2b3139;
}

.agcex-opt-chart-pnl-y-axis {
  position: absolute;
  left: -32px;
  top: 0;
  bottom: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 12px;
  color: #848e9c;
  padding-right: 8px;
  text-align: right;
  width: 32px;
}

.agcex-opt-chart-pnl-x-axis {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -24px;
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  color: #848e9c;
}

.agcex-opt-chart-pnl-grid-line {
  position: absolute;
  left: 0;
  right: 0;
  border-top: 1px dashed #e2e8f0;
  z-index: 1;
}

body.dark_theme .agcex-opt-chart-pnl-grid-line {
  border-color: #2b3139;
}

.agcex-opt-chart-pnl-marker {
  position: absolute;
  left: 85%;
  top: 10%;
  bottom: 0;
  border-left: 1px dashed #848e9c;
  z-index: 2;
}

.agcex-opt-chart-pnl-marker-label {
  position: absolute;
  top: -20px;
  left: -30px;
  font-size: 12px;
  color: #1e2329;
  white-space: nowrap;
}

body.dark_theme .agcex-opt-chart-pnl-marker-label {
  color: #eaecef;
}

.agcex-opt-chart-pnl-bottom-slider {
  position: absolute;
  bottom: -50px;
  left: 0;
  right: 0;
}

/* Candlestick specific */
.agcex-opt-chart-timeframes {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 12px;
  color: #848e9c;
  margin-bottom: 16px;
}

.agcex-opt-chart-tf-item {
  cursor: pointer;
}

.agcex-opt-chart-tf-item:hover {
  color: #1e2329;
}

body.dark_theme .agcex-opt-chart-tf-item:hover {
  color: #eaecef;
}

.agcex-opt-chart-tf-item.active {
  color: #1e2329;
  font-weight: 600;
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 4px;
}

body.dark_theme .agcex-opt-chart-tf-item.active {
  color: #eaecef;
  background: #2b3139;
}

.agcex-opt-chart-legend-row {
  font-size: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}

.agcex-opt-chart-ma-row {
  font-size: 12px;
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.agcex-opt-chart-placeholder {
  flex: 1 1;
  min-height: 230px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  border-radius: 4px;
}

body.dark_theme .agcex-opt-chart-placeholder {
  background: #181a20;
}

.agcex-opt-chart-y-axis {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  border-left: 1px dashed #e2e8f0;
  width: 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  padding-right: 4px;
  font-size: 10px;
  color: #848e9c;
}

/* --- Options Order Form Inline Styles Replacement --- */
.agcex-opt-form-info-icon {
  margin-left: auto;
  cursor: pointer;
  color: #848e9c;
}

body.dark_theme .agcex-opt-form-info-icon {
  color: #eaecef;
}

.agcex-opt-exec-type-wrap {
  cursor: pointer;
}

.agcex-opt-exec-type-text {
  flex: 1 1;
  font-size: 14px;
  color: #1e2329;
  font-weight: 500;
}

body.dark_theme .agcex-opt-exec-type-text {
  color: #eaecef;
}

.agcex-opt-input-group-price {
  margin-bottom: 4px;
}

.agcex-opt-input-wrap.no-pad-right {
  padding-right: 0;
}

.agcex-opt-input-last-price {
  color: #111111;
  font-size: 14px;
  font-weight: 500;
  margin-right: 8px;
  padding: 0 8px;
  cursor: pointer;
}

body.dark_theme .agcex-opt-input-last-price {
  color: #5c8dff;
}

.agcex-opt-input-percent {
  padding: 0 12px;
  color: inherit;
  font-weight: 500;
}

.agcex-opt-iv-text-alt {
  color: #848e9c;
  font-size: 12px;
}

.agcex-opt-input-stepper {
  display: flex;
  flex-direction: column;
  border-left: 1px solid #e2e8f0;
  background: #f8f9fa;
  width: 24px;
  height: 40px;
}

body.dark_theme .agcex-opt-input-stepper {
  border-left-color: #2b3139;
  background: #181a20;
}

.agcex-opt-stepper-btn {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.agcex-opt-stepper-btn.border-bot {
  border-bottom: 1px solid #e2e8f0;
}

body.dark_theme .agcex-opt-stepper-btn.border-bot {
  border-bottom-color: #2b3139;
}

.agcex-opt-stepper-icon {
  font-size: 12px;
  color: #848e9c;
}

body.dark_theme .agcex-opt-stepper-icon {
  color: #b7bdc6;
}

.agcex-opt-iv-text {
  font-size: 12px;
  color: #848e9c;
  margin-top: 4px;
}

.agcex-opt-iv-label {
  border-bottom: 1px dashed #848e9c;
  cursor: pointer;
}

.agcex-opt-input-unit {
  color: #1e2329;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

body.dark_theme .agcex-opt-input-unit {
  color: #eaecef;
}

.agcex-opt-position-details {
  display: flex;
  justify-content: space-between;
  padding: 7px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 12px;
  color: #848e9c;
  margin-bottom: 14px;
}

body.dark_theme .agcex-opt-position-details {
  border-color: #2b3139;
}

.agcex-opt-position-val {
  color: #1e2329;
  font-weight: 500;
}

body.dark_theme .agcex-opt-position-val {
  color: #eaecef;
}

.agcex-opt-form-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #848e9c;
  margin-bottom: 12px;
}

.agcex-opt-form-row.mb-16 {
  margin-bottom: 16px;
}

.agcex-opt-form-row.mb-0 {
  margin-bottom: 0px;
}

.agcex-opt-form-val {
  color: #eaecef;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

body.light_theme .agcex-opt-form-val {

  color: #1e2329;
}

.agcex-opt-transfer-icon {
  color: #eaecef;
  font-size: 16px;
  cursor: pointer;
}

body.light_theme .agcex-opt-transfer-icon {
  color: #1e2329;
}

.agcex-opt-submit-btn {
  border-radius: 24px;
  padding: 9px 12px;
  font-size: 14px;
  margin-bottom: 16px;
  width: 100%;
  color: #fff;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

.agcex-opt-submit-btn.buy {
  background-color: #2ebd85;
}

.agcex-opt-submit-btn.sell {
  background-color: #f6465d;
}

a.agcex-opt-submit-btn.agcex-opt-submit-btn--kyc {
  display: block;
  text-align: center;
  text-decoration: none;
  color: #fff !important;
}

a.agcex-opt-submit-btn.agcex-opt-submit-btn--kyc:hover {
  color: #fff !important;
  opacity: 0.92;
}

body.dark_theme .agcex-opt-chart-y-axis {
  border-color: #2b3139;
}

/* --- Options Row Selection --- */
.options-panel-row.selected {
  border: 1px solid #1111112e;
  background-color: #ffffff24;
}


body.light_theme .options-panel-row.selected {
  border-top-color: #eaecef !important;
  border-bottom-color: #eaecef !important;
  background-color: #fff;
}

.options-row-close-btn {
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0;
  width: 24px;
  background: #111;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  font-size: 14px;
}

body.dark_theme .options-row-close-btn {
  background: #eaecef;
  color: #111;
}

.options-row-close-btn.puts-close {
  right: auto;
  left: 0;
}

.agcex-opt-chart-x-axis {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px dashed #e2e8f0;
  height: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4px;
  font-size: 10px;
  color: #848e9c;
}

body.dark_theme .agcex-opt-chart-x-axis {
  border-top-color: #2b3139;
}

/* --- Disable Horizontal Scroll on Selection --- */

.agcex-nsh-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.trade-panel-open .mid_lft_option {
  min-width: 71.7%;
}

.agcex-nsh-tabs {
  display: flex;
  background: #f4f5f6;
  border-radius: 6px;
  padding: 2px;
}

body.dark_theme .agcex-nsh-tabs {
  background: #2b3139;
}

.agcex-nsh-tab {
  padding: 4px 12px;
  font-size: 13px;
  font-weight: 500;
  color: #848e9c;
  cursor: pointer;
  border-radius: 4px;
}

.agcex-nsh-tab.active {
  background: #fff;
  color: #1e2329;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

body.dark_theme .agcex-nsh-tab.active {
  background: #1e2329;
  color: #eaecef;
}

.agcex-opt-chart-current-price {
  position: absolute;
  left: 0;
  right: 0;
  top: 75%;
  border-top: 1px dashed #f6465d;
  z-index: 1;
}

.agcex-opt-chart-current-price-label {
  position: absolute;
  right: 0;
  top: -10px;
  background: #f6465d;
  color: #fff;
  font-size: 10px;
  padding: 2px 4px;
  border-radius: 2px;
}

/* --- Recurring Sell Panel --- */
.agcex-recurring-sell-panel {
  padding: 16px;
  border-top: 1px solid #f0f0f0;
}

body.dark_theme .agcex-recurring-sell-panel {
  border-top-color: #2b3139;
}

.rs-toggle-group {
  display: flex;
  background: #f4f5f6;
  border-radius: 6px;
  padding: 2px;
  margin-bottom: 24px;
}

body.dark_theme .rs-toggle-group {
  background: #2b3139;
}

.rs-toggle-btn {
  flex: 1 1;
  text-align: center;
  padding: 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: #848e9c;
  cursor: pointer;
  border-radius: 4px;
}

.rs-toggle-btn.active-call {
  background: #2ebd85;
  color: #fff;
}

.rs-toggle-btn.active-put {
  background: #f6465d;
  color: #fff;
}

.rs-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}

.rs-col-left,
.rs-col-right {
  display: flex;
  flex-direction: column;
}

.rs-section-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e2329;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

body.dark_theme .rs-section-title {
  color: #eaecef;
}

.rs-form-group {
  margin-bottom: 16px;
}

.rs-form-group label {
  display: block;
  font-size: 13px;
  margin-bottom: 8px;
}

.rs-label-light {
  color: #848e9c;
}

.rs-dotted-label {
  color: #848e9c;
  border-bottom: 1px dashed #848e9c;
  display: inline-block;
  cursor: pointer;
}

.rs-dotted-label-white {
  color: #fff;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.7);
  display: inline-block;
}

.rs-segment-group {
  display: flex;
  gap: 8px;
}

.rs-segment-btn {
  flex: 1 1;
  background: #f4f5f6;
  text-align: center;
  padding: 6px 0;
  border-radius: 4px;
  font-size: 13px;
  color: #1e2329;
  cursor: pointer;
  border: 1px solid transparent;
}

body.dark_theme .rs-segment-btn {
  background: #2b3139;
  color: #eaecef;
}

.rs-segment-btn.active {
  background: #fff;
  border-color: #111;
  font-weight: 500;
}

body.dark_theme .rs-segment-btn.active {
  background: #181a20;
  border-color: #eaecef;
}

.rs-delta-input-row {
  display: flex;
  align-items: stretch;
  gap: 8px;
}

.rs-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.rs-input {
  width: 100%;
  background: #f4f5f6;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  color: #1e2329;
  font-size: 14px;
  font-weight: 500;
  outline: none;
}

body.dark_theme .rs-input {
  background: #2b3139;
  color: #eaecef;
}

.rs-delta-val {
  flex: 1 1;
}

.rs-strike-toggle {
  background: #f4f5f6;
  border-radius: 4px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  color: #1e2329;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.2;
  cursor: pointer;
}

body.dark_theme .rs-strike-toggle {
  background: #2b3139;
  color: #eaecef;
}

.rs-slider-container {
  margin-top: 12px;
}

.rs-slider {
  width: 100%;
  -webkit-appearance: none;
  background: transparent;
}

.rs-slider::-webkit-slider-runnable-track {
  width: 100%;
  height: 4px;
  cursor: pointer;
  background: #e2e8f0;
  border-radius: 2px;
}

body.dark_theme .rs-slider::-webkit-slider-runnable-track {
  background: #2b3139;
}

.rs-slider::-webkit-slider-thumb {
  border: 2px solid #111;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -4px;
}

body.dark_theme .rs-slider::-webkit-slider-thumb {
  border-color: #eaecef;
}

.rs-slider-labels {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #848e9c;
  margin-top: 4px;
}

.rs-suffix {
  position: absolute;
  right: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #1e2329;
}

body.dark_theme .rs-suffix {
  color: #eaecef;
}

.rs-input-wrapper.sellamount_btc input.rs-input {
  padding-right: 52px;
}

.rs-dropdown {
  background: #f4f5f6;
  border-radius: 4px;
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #1e2329;
  cursor: pointer;
}

body.dark_theme .rs-dropdown {
  background: #2b3139;
  color: #eaecef;
}

.rs-flex-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.rs-val-dark {
  color: #1e2329;
  font-weight: 600;
}

body.dark_theme .rs-val-dark {
  color: #eaecef;
}

.rs-val-dotted {
  color: #1e2329;
  font-weight: 600;
  border-bottom: 1px dashed #1e2329;
}

body.dark_theme .rs-val-dotted {
  color: #eaecef;
  border-bottom-color: #eaecef;
}

.rs-preview-btn {
  width: 100%;
  background: #f4f5f6;
  color: #1e2329;
  font-weight: 600;
  font-size: 14px;
  padding: 12px;
  border: none;
  border-radius: 24px;
  margin-top: 24px;
  cursor: pointer;
}

body.dark_theme .rs-preview-btn {
  background: #2b3139;
  color: #eaecef;
}

.rs-risk-card {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 16px;
}

body.dark_theme .rs-risk-card {
  border-color: #2b3139;
}

.rs-risk-card-header {
  padding: 12px 16px 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

body.dark_theme .rs-risk-card-header {
  border-bottom-color: #2b3139;
}

.rs-risk-card-header .rs-dotted-label {
  color: #1e2329;
  font-weight: 500;
  font-size: 12px;
  border-bottom: none;
}

body.dark_theme .rs-risk-card-header .rs-dotted-label {
  color: #eaecef;
}

.rs-risk-card-body {
  padding: 16px;
}

.rs-summary-card {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  padding: 15px;
  margin-bottom: 16px;
}

body.dark_theme .rs-summary-card {
  border-color: #2b3139;
}

.rs-risk-level-banner {
  background: #D1AA67;
  padding: 6px 12px;
  display: flex;
  font-size: 13px;
  gap: 7px;
  justify-content: center;
  border-radius: 50px;
  align-items: center;
}

.rs-risk-level-banner .rs-dotted-label-white {
  display: inline-flex;
}

.rs-risk-badge {
  color: #fff;
  font-weight: 600;
  font-size: 15px;
}

.rs-win-rate-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 0px 0px;
  font-size: 12px;
}

body.dark_theme .rs-win-rate-row {
  background: #181a20;
}

.rs-win-rate-val {
  color: #2ebd85;
  font-weight: 600;
}

.rs-create-btn {
  width: 100%;
  background: #1e2329;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  padding: 10px;
  border: none;
  border-radius: 50px;
  cursor: pointer;
}

body.dark_theme .rs-create-btn {
  background: #eaecef;
  color: #111;
}

.trade_summary_table_lft table tr {
  border-left: 0px !important;
}

.rs-dropdown-menu {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 10;
  padding: 8px 0;
  margin-bottom: 4px;
}

body.dark_theme .rs-dropdown-menu {
  background: #181a20;
  border-color: #2b3139;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
}

.rs-dropdown-item {
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #1e2329;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

body.dark_theme .rs-dropdown-item {
  color: #eaecef;
}

.rs-dropdown-item:hover {
  background: #f4f5f6;
}

body.dark_theme .rs-dropdown-item:hover {
  background: #2b3139;
}

.rs-dropdown-item .ri-checkbox-circle-fill {
  color: #1e2329;
  font-size: 16px;
}

body.dark_theme .rs-dropdown-item .ri-checkbox-circle-fill {
  color: #eaecef;
}

/* Tickers Bar Redesign */
.options-tickers-bar {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 8px 16px;

  background: #ffffff0f;
  border-bottom: 1px solid #e2e8f03d;
}

body.light_theme .options-tickers-bar {

  background: #fff;
  border-bottom: 1px solid #e2e8f0;
}

.hdr_lft_list {
  flex: 1 1;
  min-width: 0;
}

body.dark_theme .options-tickers-bar {
  background: #181a20;
  border-bottom-color: #2b3139;
}

.options-tickers-scroll {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1 1;
}

.options-tickers-scroll::-webkit-scrollbar {
  display: none;
}

.options-scroll-arrow {
  background: none;
  border: none;
  font-size: 18px;
  color: #848e9c;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 0px;
  flex-shrink: 0;
  transition: all 0.2s;
}

body.dark_theme .options-scroll-arrow {
  background: #2b3139;
}

/* .options-scroll-arrow:hover {
  color: #1e2329;
  background: #e2e8f0;
} */

body.dark_theme .options-scroll-arrow:hover {
  color: #eaecef;
  background: #363c45;
}

.options-ticker-active-block {
  display: flex;
  align-items: center;
  gap: 12px;
}

.options-ticker-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  border-radius: 8px;
  padding: 6px 10px;
  min-width: 134px;
  border: 1px solid #e2e8f014;
  background: #f8f9fa12;
  flex-shrink: 0;
}

body.light_theme .options-ticker-item {
  border: 1px solid #e2e8f0;
  background: #f8f9fa;
}

/* .options-ticker-item:hover {
  background: #f1f5f9;
} */

.options-ticker-item.active {
  border: 1px solid #e2e8f01c;
  background: #f8f9fa36;
}

.options-ticker-bottom {
  font-size: 12px;
  line-height: 1.2;
  margin-top: 2px;
}

.options-ticker-price {
  font-weight: 600;
  color: #bdbdbd;
}

body.light_theme .options-ticker-price {
  color: #474d57;
}

.options-ticker-info-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.options-ticker-info-icon {
  font-size: 14px;
  color: #b7bdc6;
  cursor: help;
}

.options-ticker-info-icon:hover {
  color: #848e9c;
}

.options-ticker-info-tip {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 50;
  width: 260px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  pointer-events: none;
}

body.dark_theme .options-ticker-info-tip {
  background: #1e2329;
  border-color: #2b3139;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
}

.options-ticker-info-tip__title {
  font-size: 13px;
  font-weight: 600;
  color: #1e2329;
  margin-bottom: 6px;
}

body.dark_theme .options-ticker-info-tip__title {
  color: #eaecef;
}

.options-ticker-info-tip__text {
  margin: 0 0 10px;
  font-size: 12px;
  line-height: 1.45;
  color: #848e9c;
  white-space: normal;
}

.options-ticker-info-tip__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 12px;
  color: #848e9c;
}

.options-ticker-info-tip__row+.options-ticker-info-tip__row {
  margin-top: 6px;
}

.options-ticker-info-tip__row span:last-child {
  color: #1e2329;
  font-weight: 500;
  white-space: nowrap;
}

body.dark_theme .options-ticker-info-tip__row span:last-child {
  color: #eaecef;
}

.options-ticker-coin-img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.options-ticker-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.options-ticker-top {
  display: flex;
  align-items: center;
  gap: 4px;
}

.options-ticker-symbol {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
}

body.light_theme .options-ticker-symbol {
  color: #1e2329;
}

.options-ticker-arrow {
  color: #848e9c;
  font-size: 16px;
}

.options-ticker-scm-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f4f5f6;
  border: none;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #1e2329;
  cursor: pointer;
}

body.dark_theme .options-ticker-scm-btn {
  background: #2b3139;
  color: #eaecef;
}

.options-ticker-margin-block {
  display: flex;
  align-items: center;
  gap: 24px;
  padding-left: 20px;
  border-left: 1px solid #e2e8f0;
}

body.dark_theme .options-ticker-margin-block {
  border-left-color: #2b3139;
}

.margin-col {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.margin-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.margin-label {
  color: #eaecef;
  font-weight: 600;
}

body.light_theme .margin-label {
  color: #1e2329;
}

.margin-label.dotted {
  border-bottom: 1px dashed #b7bdc6;
  cursor: pointer;
}

.margin-val {
  font-weight: 600;
}

.margin-val.text-green {
  color: #2ebd85;
}

.margin-progress {
  width: 40px;
  height: 4px;
  background: #e2e8f0;
  border-radius: 2px;
  overflow: hidden;
}

body.dark_theme .margin-progress {
  background: #2b3139;
}

.progress-fill {
  height: 100%;
  background: #b7bdc6;
}

/* Switch Account Mode Modal Styles */
.agcx-accmode-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1050;
}

.agcx-accmode-modal {
  position: fixed;
  top: 0;
  right: 0;
  width: 420px;
  height: 100vh;
  background: #ffffff;
  z-index: 9999999;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.1);
  font-family: inherit;
}

body.dark_theme .agcx-accmode-modal {
  background: #181a20;
  color: #eaecef;
}

.agcx-accmode-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
}

body.dark_theme .agcx-accmode-header {
  border-bottom-color: #2b3139;
}

.agcx-accmode-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #1e2329;
}

body.dark_theme .agcx-accmode-title {
  color: #eaecef;
}

.agcx-accmode-title i.ri-arrow-left-s-line {
  font-size: 24px;
  cursor: pointer;
  color: #1e2329;
}

body.dark_theme .agcx-accmode-title i.ri-arrow-left-s-line {
  color: #eaecef;
}

.agcx-accmode-help {
  font-size: 16px;
  color: #848e9c;
  cursor: pointer;
}

.agcx-accmode-history {
  font-size: 20px;
  color: #848e9c;
  cursor: pointer;
}

.agcx-accmode-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.agcx-accmode-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.2s;
}

body.dark_theme .agcx-accmode-card {
  border-color: #2b3139;
  background: #181a20;
}

.agcx-accmode-card.active {
  border-color: #1e2329;
  box-shadow: 0 0 0 1px #1e2329;
}

body.dark_theme .agcx-accmode-card.active {
  border-color: #f0b90b;
  box-shadow: 0 0 0 1px #f0b90b;
}

.agcx-accmode-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.agcx-accmode-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e2329;
  display: flex;
  align-items: center;
  gap: 8px;
}

body.dark_theme .agcx-accmode-card-title {
  color: #eaecef;
}

.badge-gray {
  background: #f4f5f6;
  color: #848e9c;
  font-size: 11px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 4px;
}

body.dark_theme .badge-gray {
  background: #2b3139;
}

.active-icon {
  font-size: 18px;
  color: #1e2329;
}

body.dark_theme .active-icon {
  color: #f0b90b;
}

.agcx-accmode-card-desc {
  font-size: 13px;
  color: #707a8a;
  margin-bottom: 12px;
}

.agcx-accmode-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 16px;
}

.agcx-accmode-tags span {
  background: #f4f5f6;
  color: #707a8a;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
}

body.dark_theme .agcx-accmode-tags span {
  background: #2b3139;
  color: #848e9c;
}

.agcx-accmode-showmore {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #848e9c;
  cursor: pointer;
  margin-top: 8px;
}

.agcx-accmode-showmore:hover {
  color: #1e2329;
}

body.dark_theme .agcx-accmode-showmore:hover {
  color: #eaecef;
}

.agcx-accmode-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-top: 1px solid #e2e8f0;
  font-size: 13px;
  color: #1e2329;
  font-weight: 500;
}

body.dark_theme .agcx-accmode-toggle-row {
  border-top-color: #2b3139;
  color: #eaecef;
}

/* Switch Styles */
.agcx-toggle-switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
}

.agcx-toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.agcx-toggle-switch .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.agcx-toggle-switch .slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: .4s;
}

.agcx-toggle-switch input:checked+.slider {
  background-color: #2ebd85;
}

.agcx-toggle-switch input:checked+.slider:before {
  transform: translateX(16px);
}

.agcx-toggle-switch .slider.round {
  border-radius: 20px;
}

.agcx-toggle-switch .slider.round:before {
  border-radius: 50%;
}

/* Switch Account Mode More content style */
.agcx-accmode-more-content {
  border-top: 1px solid #e2e8f0;
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

body.dark_theme .agcx-accmode-more-content {
  border-top-color: #2b3139;
}

.agcx-accmode-more-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.more-sec-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e2329;
}

body.dark_theme .more-sec-title {
  color: #eaecef;
}

.more-sec-list {
  list-style: none;
  padding-left: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.more-sec-list li {
  position: relative;
  font-size: 12px;
  color: #707a8a;
  padding-left: 14px;
  line-height: 1.5;
}

.more-sec-list li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #848e9c;
}

.more-sec-link {
  font-size: 12px;
  color: #1e2329;
  text-decoration: underline;
  font-weight: 600;
}

body.dark_theme .more-sec-link {
  color: #eaecef;
}

.agcx-accmode-footer {
  padding: 16px 20px;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
}

body.dark_theme .agcx-accmode-footer {
  border-top-color: #2b3139;
  background: #181a20;
}

.agcx-accmode-footer-btn {
  width: 100%;
  padding: 12px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  background: #f4f5f6;
  color: #aeaeae;
  cursor: not-allowed;
}

.more-sec-link:hover {
  color: #080808;
}

body.dark_theme .agcx-accmode-footer-btn {
  background: #2b3139;
  color: #707a8a;
}

/* Scroll lock when modal is open */
body.modal-open,
html.modal-open,
.agcex-options-wrapper.modal-open {
  overflow: hidden !important;
  height: 100vh !important;
}

.agcx-accmode-footer-btn.active-btn {
  background: #D1AA67;
  color: #ffffff;
  cursor: pointer;
}

.agcx-accmode-footer-btn.active-btn:hover {
  background: #deac57;
}

.agcex-opt-orderbook .agcex-opt-ob-mid .agcex-text-right {
  text-align: left;
}


@media screen and (max-width: 1550px) {


  .agcex-options-wrapper {
    margin-top: 0px;
  }

  .trade-panel-open .mid_lft_option {
    min-width: 61.7%;
  }

}


@media screen and (max-width: 1200px) {

  .order_history_mobile_view.twomobile div {
    border-left: 0px !important;
  }


  .assets_right.assets_panel_desktop.option_assetsright {
    max-width: 100%;
    min-width: 100%;
  }

}

@media screen and (max-width: 1024px) {

  body.has-sidebar-open,
  html.has-sidebar-open {
    overflow: hidden !important;
    height: 100vh !important;
  }

  body.dark_theme .agcex-opt-pct-slider-track {
    background: #525252;
  }

  .agcex-options-sidebar-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgb(255 255 255 / 20%);
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    z-index: 9999999;
  }

  .mid_right_option {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    width: 100vw !important;
    max-width: 100vw !important;
    min-width: unset !important;
    height: 85vh !important;
    max-height: 85vh !important;
    border-radius: 16px 16px 0 0 !important;
    z-index: 99999999999 !important;
    box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.25) !important;
    overflow-y: auto !important;
    animation: slideUpMobile 0.3s ease-out;
  }

  .options-recent-trades-panel {
    width: 50%;
  }

  .mid_right_option.is-open {
    flex-direction: column;
  }

  .agcex-options-trade-center {
    flex: 1 1;
    /* overflow-y: auto; */
    display: flex;
    flex-direction: row;
    padding-bottom: 30px;
  }

  @keyframes slideUpMobile {
    from {
      transform: translateY(100%);
    }

    to {
      transform: translateY(0);
    }
  }

}



/* Mobile Favourites Popup for Options page */
.mobile-favourites-popup-overlay-options {
  display: none;
}

@media screen and (max-width: 991px) {

  .desktop-favourites-dropdown {
    display: none !important;
  }

  .mobile-favourites-popup-options .orderbook-table th {
    background: none;
  }

  /* body.light_theme .mobile-favourites-popup-options .orderbook-table th {
    background: #ffffff;
  } */

  .mobile-favourites-popup-overlay-options {
    display: flex !important;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgb(24 24 24 / 20%);
    z-index: 999999999;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    align-items: flex-end;
    justify-content: center;
    animation: fadeIn 0.3s ease;
  }

  body.light_theme .mobile-favourites-popup-overlay-options {
    background-color: rgb(255 255 255 / 20%);
  }

  .mobile-favourites-popup-options {
    width: 100%;
    max-height: 85vh;
    background-color: #161616de;
    display: flex;
    flex-direction: column;
    animation: slideUpMobile 0.3s ease;
    overflow: hidden;
    border-radius: 16px 16px 0px 0px;
  }

  body.light_theme .mobile-favourites-popup-options {
    background-color: #ffffffc4;
    ;
  }

  .mobile-favourites-popup-header-options {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border-bottom: 1px solid #f0f0f01a;
  }

  body.light_theme .mobile-favourites-popup-header-options {
    border-bottom: 1px solid #f0f0f0;
  }

  .mobile-favourites-popup-header-options h4 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #ededed;
  }

  body.light_theme .mobile-favourites-popup-header-options h4 {
    color: #1e2329;
  }

  .mobile-favourites-close-btn-options {
    background: transparent;
    border: none;
    color: #848e9c;
    padding: 0px;
    font-size: 24px;
    cursor: pointer;
    line-height: 1;
  }

  .mobile-favourites-popup-content-options {
    flex: 1 1;
    overflow-y: auto;
    padding: 16px;
  }

  .mobile-favourites-popup-content-options .spotLists {
    display: block !important;
    position: static !important;
    width: 100% !important;
    box-shadow: none !important;
    padding: 0 !important;
    background: none !important;
    -webkit-backdrop-filter: inherit;
            backdrop-filter: inherit;
  }

  .options-scroll-arrow {
    padding: 0px;
    width: auto;
    height: auto;
  }

  .options-tickers-bar {
    gap: 5px;
    padding: 8px 10px;
  }

}


@media screen and (max-width: 767px) {

  .options-recent-trades-container {
    flex-direction: column;
  }

  .options-filter-row {
    padding: 8px 6px 10px;
  }

  .options-ai-row {
    padding: 16px 10px 8px;
  }

  .agcex-opt-modal {
    top: inherit;
    bottom: 0px;
    transform: translate(-50%, -0%);
    border-radius: 12px 12px 0px 0px;
  }

  .options-recent-trades-panel {
    width: 100%;
  }

  .options-ticker-margin-block {
    width: 100%;
    border: none;
  }

  .options-ticker-margin-block .margin-col {
    width: 100%;
  }


  .hdr_lft_list {
    flex: none;
  }

}


@media screen and (max-width: 660px) {

  .options-tickers-bar {
    flex-direction: column;
  }

  .hdr_lft_list {
    width: 100%;
  }

  .agcex-opt-orderbook {
    width: 100%;
  }

  .agcex-opt-orderform {
    width: 100%;
  }

  .agcex-nsh-actions {
    gap: 5px;
  }

  i.ri-information-fill.agcex-nsh-info {
    display: none;
  }

  .options-ticker-margin-block {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-left: 0px;
    border-left: none;
  }

  .agcex-opt-group-info.right {
    display: none;
  }

  .agcex-opt-group-info.left {
    display: none;
  }

  .agcex-options-trade-center {
    flex-direction: column;
  }

  .agcex-nsh-title {
    font-size: 14px;
  }

  .agcex-nsh-tab {
    padding: 4px 8px;
    font-size: 12px;
  }

  .rs-grid {
    grid-template-columns: 1fr;
  }

  .agcx-accmode-modal {
    width: 90%;
  }

}

/* Recent Trades Cardbox view styles */
.mobile-only-cards {
  display: none;
}

.options-trade-card {
  background: #fafafa;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #f0f0f0;
}

body.dark_theme .options-trade-card {
  background: #181a20;
  border-color: #2b3139;
}

.options-trade-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  border-bottom: 1px dashed #f0f0f0;
  padding-bottom: 6px;
}

body.dark_theme .options-trade-card-header {
  border-bottom-color: #2b3139;
}

.options-trade-card-header .trade-symbol {
  font-size: 13px;
  font-weight: 600;
  color: #1e2329;
}

body.dark_theme .options-trade-card-header .trade-symbol {
  color: #eaecef;
}

.options-trade-card-header .trade-time {
  font-size: 11px;
  color: #848e9c;
}

.options-trade-card-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.options-trade-card-body .trade-col {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.options-trade-card-body .trade-label {
  font-size: 11px;
  color: #848e9c;
}

.options-trade-card-body .trade-val {
  font-size: 12px;
  font-weight: 500;
  color: #1e2329;
}

body.dark_theme .options-trade-card-body .trade-val {
  color: #eaecef;
}

@media screen and (max-width: 767px) {
  .desktop-only-table {
    display: none !important;
  }

  .mobile-only-cards {
    display: flex !important;
    flex-direction: column;
    gap: 8px;
    padding: 10px;
  }

  .options-ticker-symbol {
    font-size: 12px;
  }

  .options-ticker-price {
    font-size: 11px;
  }

  .agcex-opt-exec-type-text {
    font-size: 12px;
  }

  .agcex-opt-input-wrap input {
    font-size: 12px;
  }

  .agcex-opt-input-unit {
    font-size: 12px;
  }

  .agcex-opt-submit-btn {
    padding: 8px 12px;
    font-size: 13px;
  }

  .agcex-opt-input-last-price {
    font-size: 12px;
  }

  .rs-toggle-btn {
    padding: 7px 0;
    font-size: 13px;
  }

  .rs-preview-btn {
    font-size: 13px;
    padding: 9px;
    margin-top: 18px;
  }

  .rs-input {
    font-size: 12px;
  }

  .rs-segment-btn {
    font-size: 12px;
  }

  .rs-dropdown {
    font-size: 12px;
  }

}

/* Mark Slider Popup */
.agcex-opt-mark-slider-popup {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  padding: 16px;
  width: 280px;
  z-index: 100;
  border: 1px solid #e2e8f0;
}

body.dark_theme .agcex-opt-mark-slider-popup {
  background: #1e2329;
  border-color: #2b3139;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);
}

.agcex-opt-mark-slider-wrapper {
  position: relative;
  width: 100%;
}

.agcex-opt-mark-slider-input {
  -webkit-appearance: none;
  width: 100%;
  height: 4px;
  background: #e2e8f0;
  border-radius: 2px;
  outline: none;
  margin: 12px 0;
}

body.dark_theme .agcex-opt-mark-slider-input {
  background: #2b3139;
}

.agcex-opt-mark-slider-input::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  border: 3px solid #1e2329;
  cursor: pointer;
}

body.dark_theme .agcex-opt-mark-slider-input::-webkit-slider-thumb {
  background: #1e2329;
  border-color: #eaecef;
}

.agcex-opt-mark-slider-labels {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #848e9c;
  font-weight: 500;
}

/* Limit Price/IV Toggle Button */
.agcex-opt-limit-toggle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #f8f9fa;
  border-radius: 6px;
  cursor: pointer;
  color: #1e2329;
  font-size: 16px;
  transition: all 0.2s;
}

body.dark_theme .agcex-opt-limit-toggle-btn {
  background: #1e2329;
  color: #eaecef;
}

/* .agcex-opt-limit-toggle-btn:hover {
  background: #e2e8f0;
} */
/* 
body.dark_theme .agcex-opt-limit-toggle-btn:hover {
  background: #2b3139;
} */

.agcex-opt-limit-toggle-btn i {
  font-weight: bold;
}

/* Limit Price Input Row */
.agcex-opt-limit-price-row {
  display: flex;
  gap: 8px;
  width: 100%;
}

/* Fix for input overflow in flex container */
.agcex-opt-input-wrap {
  min-width: 0;
}

.agcex-opt-input-wrap input {
  min-width: 0;
}

.agcex-opt-limit-toggle-btn {
  flex-shrink: 0;
}

.agcex-opt-limit-price-row .agcex-opt-input-wrap {
  flex: 1 1;
}

/* —— Options page loading skeletons —— */
@keyframes options-sk-shimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}

.options-sk__bone {
  display: block;
  border-radius: 4px;
  background: linear-gradient(90deg, #2a2e36 0%, #3a3f4a 45%, #2a2e36 90%);
  background-size: 200% 100%;
  animation: options-sk-shimmer 1.35s ease-in-out infinite;
}

body.light_theme .options-sk__bone {
  background: linear-gradient(90deg, #e8eaed 0%, #f1f5f9 45%, #e8eaed 90%);
  background-size: 200% 100%;
  animation: options-sk-shimmer 1.35s ease-in-out infinite;
}

.options-sk__coin {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;
}

.options-sk__line {
  height: 12px;
  border-radius: 4px;
}

.options-sk__line--xs {
  width: 36px;
}

.options-sk__line--sm {
  width: 52px;
}

.options-sk__line--md {
  width: 72px;
}

.options-sk__line--lg {
  width: 140px;
}

.options-sk__line--val {
  width: 80px;
  height: 14px;
}

.options-sk__line--price {
  width: 88px;
  height: 16px;
}

.options-sk__line--strike {
  width: 56px;
  height: 14px;
  margin: 0 auto;
}

.options-sk__ticker {
  pointer-events: none;
  cursor: default;
}

.options-sk__expiry-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}

.options-sk__date-pill {
  width: 88px;
  height: 28px;
  border-radius: 999px;
  flex-shrink: 0;
}

.options-sk-chain {
  width: 100%;
  padding: 8px 0 16px;
}

.options-sk-chain__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  margin-bottom: 4px;
  border-bottom: 1px solid #2b3139;
}

body.light_theme .options-sk-chain__header {
  border-bottom-color: #e2e8f0;
}

.options-sk-chain__row {
  display: flex;
  align-items: center;
  gap: 0;
  min-height: 36px;
  border-bottom: 1px solid rgba(43, 49, 57, 0.45);
}

body.light_theme .options-sk-chain__row {
  border-bottom-color: rgba(226, 232, 240, 0.9);
}

.options-sk-chain__side {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 6px 10px;
  overflow: hidden;
}

.options-sk-chain__side:last-child {
  justify-content: flex-start;
}

.options-sk-chain__strike {
  flex: 0 0 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 4px;
  border-left: 1px solid rgba(43, 49, 57, 0.45);
  border-right: 1px solid rgba(43, 49, 57, 0.45);
}

body.light_theme .options-sk-chain__strike {
  border-left-color: rgba(226, 232, 240, 0.9);
  border-right-color: rgba(226, 232, 240, 0.9);
}

.options-sk__cell {
  width: 44px;
  height: 12px;
  flex-shrink: 0;
}

.options-table-container.is-loading-chain .options-global-header {
  opacity: 0.55;
  pointer-events: none;
}

.options-table-container.is-loading-chain .options-global-body {
  min-height: 360px;
}

.options-global-body--skeleton {
  display: block;
  width: 100%;
  min-height: 360px;
  padding: 0 4px;
}

.options-global-body--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 360px;
  padding: 48px 24px;
}

.options-chain-empty-msg {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #848e9c;
  text-align: center;
}

body.light_theme .options-chain-empty-msg {
  color: #848e9c;
}

body.dark_theme .options-chain-empty-msg {
  color: #848e9c;
}

/* Positions — exercise-style table (expiry, two-line symbol, long/short) */
.agcex-opt-positions-table.spot_orders_table thead th {
  color: #848e9c;
  font-weight: 400;
  font-size: 12px;
  border-bottom: 1px solid #eaecef36;
  white-space: nowrap;
  padding: 10px 8px;
}

body.light_theme .agcex-opt-positions-table.spot_orders_table thead th {
  border-bottom: 1px solid #eaecef;
}

.agcex-opt-positions-table.spot_orders_table tbody td {
  font-size: 13px;
  vertical-align: middle;
  border-bottom: 1px solid #f0f1f217;
  padding: 12px 8px;
}

body.light_theme .agcex-opt-positions-table.spot_orders_table tbody td {
  border-bottom: 1px solid #f0f1f2;
}

.agcex-opt-positions-table.spot_orders_table tbody tr:hover {
  background: rgba(0, 0, 0, 0.015);
}

.agcex-opt-pos-muted {
  color: #474d57;
  white-space: nowrap;
}

.agcex-opt-pos-symbol {
  position: relative;
  padding-left: 10px;
  min-width: 120px;
}

.agcex-opt-pos-symbol::before {
  content: "";
  position: absolute;
  left: 0;
  top: 2px;
  bottom: 2px;
  width: 3px;
  border-radius: 2px;
  background: var(--agcex-opt-pos-accent, #848e9c);
}

.agcex-opt-pos-symbol__primary {
  font-weight: 600;
  line-height: 1.35;
  color: inherit;
}

.agcex-opt-pos-symbol__secondary {
  font-size: 12px;
  color: #848e9c;
  line-height: 1.35;
}

body.dark_theme .agcex-opt-positions-table.spot_orders_table thead th {
  color: #848e9c;
  border-bottom-color: #2b3139;
}

body.dark_theme .agcex-opt-positions-table.spot_orders_table tbody td {
  border-bottom-color: #2b3139;
}

body.dark_theme .agcex-opt-positions-table.spot_orders_table tbody tr:hover {
  background: rgba(255, 255, 255, 0.02);
}

body.dark_theme .agcex-opt-pos-muted {
  color: #b7bdc6;
}

body.dark_theme .agcex-opt-pos-symbol__secondary {
  color: #848e9c;
}

/* Open positions PnL — beat .trade_summary_table_lft tr td color rules */
.trade_summary_table_lft .agcex-opt-positions-table.spot_orders_table tbody td.agce-ft-pnl--profit,
.trade_summary_table_lft .agcex-opt-positions-table.spot_orders_table tbody td.agce-ft-pnl--loss,
.trade_summary_table_lft .so-mobileCard__row>span.agce-ft-pnl--profit,
.trade_summary_table_lft .so-mobileCard__row>span.agce-ft-pnl--loss {
  font-weight: 500;
}

.trade_summary_table_lft .agcex-opt-positions-table.spot_orders_table tbody td.agce-ft-pnl--profit,
.trade_summary_table_lft .so-mobileCard__row>span.agce-ft-pnl--profit {
  color: #0ecb81 !important;
}

.trade_summary_table_lft .agcex-opt-positions-table.spot_orders_table tbody td.agce-ft-pnl--loss,
.trade_summary_table_lft .so-mobileCard__row>span.agce-ft-pnl--loss {
  color: #f6465d !important;
}

/* Positions — Binance-style inline close (Close + price + qty pills) */
.agcex-opt-close-pos-cell {
  vertical-align: middle !important;
  text-align: right;
  white-space: nowrap;
}

.agcex-opt-close-pos {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-width: 0;
}

.agcex-opt-close-pos__label {
  border: none;
  background: transparent;
  color: #f3bb2b;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
}

.agcex-opt-close-pos__label:hover:not(:disabled) {
  opacity: 0.85;
}

.agcex-opt-close-pos__label:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.agcex-opt-close-pos__input {
  width: 72px;
  min-width: 56px;
  border: none;
  border-radius: 999px;
  background: #f0f1f2;
  color: #191919;
  font-size: 12px;
  line-height: 1.2;
  padding: 6px 10px;
  text-align: center;
  outline: none;
}

.agcex-opt-close-pos__input:focus {
  background: #e8eaed;
}

.agcex-opt-close-pos__input:disabled {
  opacity: 0.6;
}

body.dark_theme .agcex-opt-close-pos__input {
  background: #2b3139;
  color: #eaecef;
}

body.dark_theme .agcex-opt-close-pos__input:focus {
  background: #363c45;
}

.trade_summary_table_lft .spot_orders_table thead th.yellowcolor {
  text-align: end;
  color: #d0aa67;
}

.so-mobileCard__row .agcex-opt-close-pos {
  width: 100%;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.agcex-opt-ob-wrapper {
  height: 300px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}


.agcex-opt-trades-scroll {
  max-height: 104px;
  overflow-y: auto;
  overflow-x: hidden;
}

.agcex-trade-col-wrapper {
  width: 100%;
}

@media (min-width: 992px) {
  .agcex-trade-col-wrapper {
    width: 50%;
    flex: 1 1;
  }
}

@media (min-width: 992px) {
  .mobile-trade-tabs {
    display: none !important;
  }
}

.mobile-trade-tabs {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #33363d;
  margin-top: 12px;
  position: relative;
  cursor: pointer;
}

.mobile-trade-tab::before {
  width: 30px;
  position: absolute;
  content: "";
  height: 2px;
  background: #fff;
  bottom: -2px;
  margin: 0 auto;
  right: 0px;
  opacity: 0;
  left: 0px;
}

body.light_theme .mobile-trade-tab::before {
  background: #000;
}

.mobile-trade-tab.active::before {
  opacity: 1;
}

body.light_theme .mobile-trade-tabs {
  border-bottom-color: #e2e8f0;
}

.mobile-trade-tab {
  text-align: center;
  padding: 10px;
  position: relative;
  font-weight: bold;
  color: #848e9c;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
}

.mobile-trade-tab.active {
  color: #fff;
}

body.light_theme .mobile-trade-tab.active {
  color: #000;
}


@media screen and (max-width:660px) {


  .options-tickers-scroll {
    gap: 10px;
    flex: auto;
  }


  .options-tickers-scroll .options-ticker-active-block {
    width: 100%;
  }

  .options-tickers-scroll .options-ticker-item {
    width: 50%;
  }


  .options-tickers-scroll .options-ticker-active-block .options-ticker-item {
    width: 100%;
  }

  .options-ticker-item {
    min-width: auto;
  }

  .options-ticker-coin-img {
    width: 22px;
    height: 22px;
  }

}

@media screen and (max-width:480px) {
  .options-ticker-item {
    gap: 5px;
    padding: 5px 5px;
  }

  .options-tickers-bar {
    padding: 8px 7px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/options/options.css"],"names":[],"mappings":"AAAA;;kFAEkF;;AAElF;EACE,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,SAAO;EACP,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,SAAO;EACP,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,iCAAiC;EACjC,mBAAmB;EACnB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;;AAErB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;;AAEjB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,8DAA8D;EAC9D,2DAA2D;AAC7D;;AAEA;;EAEE,yCAAyC;EACzC,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kCAAkC;EAClC,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;EACd,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,aAAa;AACb;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,4BAA4B;;EAE5B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAO;EACP,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,SAAO;AACT;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,SAAS;EACT,sCAAsC;EACtC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,sCAAsC;EACtC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EACxB,+CAA+C;EAC/C,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,iCAAiC;EACjC,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,QAAQ;AACV;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,+BAA+B;EAC/B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;;AAGA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mDAAmD;;AAEnD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;;EAEjB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;GAGG;;AAEH;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mCAAmC;AACnC;;;EAGE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;;;EAGE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;;AAGA;;EAEE;IACE,2BAA2B;EAC7B;;;EAGA;IACE,eAAe;IACf,eAAe;EACjB;;AAEF;;AAEA;;EAEE;;IAEE,2BAA2B;IAC3B,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC,kCAA0B;YAA1B,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,uCAAuC;IACvC,+BAA+B;IAC/B,sDAAsD;IACtD,2BAA2B;IAC3B,sCAAsC;EACxC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAS;IACT,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE;MACE,2BAA2B;IAC7B;;IAEA;MACE,wBAAwB;IAC1B;EACF;;AAEF;;;;AAIA,6CAA6C;AAC7C;EACE,aAAa;AACf;;AAEA;;EAEE;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;KAEG;;EAEH;IACE,wBAAwB;IACxB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,qCAAqC;IACrC,kBAAkB;IAClB,kCAA0B;YAA1B,0BAA0B;IAC1B,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;;EAE7B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;IAC3B,qBAAqB;IACrB,2BAA2B;IAC3B,gCAAwB;YAAxB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,iBAAiB;EACnB;;AAEF;;;AAGA;;EAEE;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,+BAA+B;IAC/B,gCAAgC;EAClC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;;EAGA;IACE,UAAU;EACZ;;AAEF;;;AAGA;;EAEE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;AAEF;;AAEA,sCAAsC;AACtC;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;GAEG;AACH;;;GAGG;;AAEH;EACE,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA,yCAAyC;AACzC;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wEAAwE;EACxE,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,wEAAwE;EACxE,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,yEAAyE;AACzE;;;;EAIE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,uEAAuE;AACvE;EACE,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;;AAGA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,SAAO;EACT;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,UAAU;EACV,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;;AAGA;;;EAGE;IACE,SAAS;IACT,UAAU;EACZ;;;EAGA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;;EAGA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;AAEF;;AAEA;EACE;IACE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;AAEF","sourcesContent":["/* =============================================================================\n   Options Trading Page CSS\n   ============================================================================= */\n\n.agcex-options-wrapper {\n  background: #171a20;\n  color: #e7e7e7;\n  font-family: \"Inter\", sans-serif;\n  min-height: 100vh;\n  padding: 7px 8px 8px;\n  display: flex;\n  flex-direction: column;\n}\n\nbody.light_theme .agcex-options-wrapper {\n  background: #f8f9fa;\n  color: #0b0e11;\n}\n\n.agcex-options-wrapper .trade_summary_table_lft_position_order.position_order {\n  border-radius: 8px;\n}\n\n/* --- Tickers Bar --- */\n.options-tickers-bar {\n  display: flex;\n  align-items: center;\n  padding: 12px 24px;\n  border-bottom: none;\n  gap: 24px;\n  background-color: #fff;\n  border-radius: 8px;\n  scrollbar-width: none;\n}\n\nbody.dark_theme .options-tickers-bar {\n  border-bottom-color: #2b3139;\n}\n\n.options-tickers-bar::-webkit-scrollbar {\n  display: none;\n}\n\n.options-ticker-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n  transition: background 0.2s;\n  white-space: nowrap;\n}\n\n\n.options-ticker-item.active {\n  background: #f4f5f614;\n}\n\nbody.light_theme .options-ticker-item.active {\n  background: #e2e8f0;\n}\n\n.options-ticker-icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  object-fit: contain;\n}\n\n.options-ticker-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.options-ticker-symbol {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\nbody.dark_theme .options-ticker-symbol {\n  color: #eaecef;\n}\n\n.options-ticker-price {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.text-green {\n  color: #02c076 !important;\n}\n\n.text-danger {\n  color: #f84960 !important;\n}\n\n.text-muted {\n  color: #848e9c !important;\n}\n\n/* --- AI Expiration Row --- */\n.options-ai-row {\n  display: flex;\n  align-items: center;\n  padding: 16px 24px 8px;\n  gap: 16px;\n  background: #ffffff0f;\n  margin: 0px 0px;\n  border-radius: 8px 8px 0px 0px;\n  position: relative;\n}\n\nbody.light_theme .options-ai-row {\n  background-color: #fff;\n}\n\n.options-dates-scroll {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  overflow-x: auto;\n  white-space: nowrap;\n  flex: 1;\n  scrollbar-width: none;\n  min-width: 0;\n}\n\n.options-dates-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.options-dates-scroll-arrow {\n  background: none;\n  border: none;\n  font-size: 18px;\n  color: #848e9c;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 0px;\n  flex-shrink: 0;\n  transition: all 0.2s;\n  padding: 0;\n}\n\n.options-dates-scroll-arrow:hover {\n  color: #1e2329;\n}\n\nbody.dark_theme .options-dates-scroll-arrow:hover {\n  color: #eaecef;\n}\n\n.options-ai-btn {\n  background-color: #34363c;\n  color: #eaecef;\n  border: none;\n  padding: 3px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.2s, color 0.2s;\n}\n\nbody.light_theme .options-ai-btn {\n  color: #474d57;\n  background-color: #f2f3f4;\n}\n\n.options-date-btn {\n  background: transparent;\n  border: none;\n  font-size: 12px;\n  font-weight: 500;\n  color: #eaecef;\n  padding: 3px 10px;\n  background-color: #34363c;\n  border-radius: 6px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.2s, color 0.2s;\n}\n\nbody.light_theme .options-date-btn {\n  color: #474d57;\n  background-color: #f2f3f4;\n}\n\n.options-ai-btn.active,\n.options-date-btn.active {\n  background: #1e2329;\n  color: #fff;\n}\n\nbody.light_theme .options-ai-btn.active,\nbody.light_theme .options-date-btn.active {\n  background: #1e2329;\n  color: #fff;\n}\n\nbody.dark_theme .options-date-btn:hover:not(.active),\nbody.dark_theme .options-ai-btn:hover:not(.active) {\n  background: #2b3139;\n}\n\nbody.light_theme .options-date-btn:hover:not(.active),\nbody.light_theme .options-ai-btn:hover:not(.active) {\n  background: #e8eaed;\n}\n\n/* --- Filter Row --- */\n.options-filter-row {\n  display: flex;\n  align-items: center;\n  padding: 8px 24px 16px;\n  gap: 16px;\n  background: #26292f;\n  border-radius: 0px 0px 8px 8px;\n  margin-bottom: 4px;\n  position: relative;\n}\n\nbody.light_theme .options-filter-row {\n  background-color: #ffffff;\n}\n\n.options-filters-scroll {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  overflow-x: auto;\n  white-space: nowrap;\n  flex: 1;\n  scrollbar-width: none;\n  min-width: 0;\n}\n\n.options-filters-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.options-filters-scroll>* {\n  flex-shrink: 0 !important;\n}\n\n.options-filters-scroll-arrow {\n  background: none;\n  border: none;\n  font-size: 18px;\n  color: #848e9c;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 0px;\n  flex-shrink: 0;\n  transition: all 0.2s;\n  padding: 0;\n}\n\n.options-filters-scroll-arrow:hover {\n  color: #1e2329;\n}\n\nbody.dark_theme .options-filters-scroll-arrow:hover {\n  color: #eaecef;\n}\n\n.options-global-header {\n  background: #f8f9fa !important;\n}\n\n.options-filter-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #d1d1d1;\n  font-weight: 500;\n}\n\nbody.light_theme .options-filter-group {\n  color: #474d57;\n}\n\n.options-checkbox {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.options-input,\n.options-select {\n  border: 1px solid #e2e8f00f;\n  border-radius: 4px;\n  padding: 4px 8px;\n  font-size: 12px;\n  color: #ffffff;\n  background: #34363c;\n  outline: none;\n}\n\nbody.light_theme .options-input,\nbody.light_theme .options-select {\n  border-color: #e2e8f0;\n  background: #fff;\n  color: #0f172a;\n\n}\n\n.options-reset-btn {\n  background: transparent;\n  border: none;\n  color: #848e9c;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.options-position-builder-btn {\n  margin-left: auto;\n  background: #2b3139;\n  color: #fff;\n  border: none;\n  padding: 6px 16px;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.options-position-builder-btn i {\n  font-size: 16px;\n}\n\n/* --- Table Layout Redesign --- */\n.options-table-container {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 580px;\n  max-height: 580px;\n  min-height: 580px;\n  border-radius: 8px;\n}\n\n.options-panels-wrapper {\n  display: flex;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\nbody.dark_theme .options-panels-wrapper {\n  border-top-color: #2b3139;\n}\n\n.options-panel {\n  display: flex;\n  flex-direction: column;\n}\n\n.options-panel-header {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: #f8f9fa;\n}\n\nbody.dark_theme .options-panel-header {\n  background: #0b0e11;\n}\n\n.calls-panel,\n.puts-panel {\n  flex: 1;\n  overflow-x: auto;\n  overflow-y: visible;\n  background: #26292f;\n}\n\nbody.light_theme .calls-panel,\nbody.light_theme .puts-panel {\n  background: #fff;\n}\n\n.calls-panel::-webkit-scrollbar,\n.puts-panel::-webkit-scrollbar {\n  height: 6px;\n}\n\n.calls-panel::-webkit-scrollbar-thumb,\n.puts-panel::-webkit-scrollbar-thumb {\n  background: #e2e8f0;\n  border-radius: 3px;\n}\n\nbody.dark_theme .calls-panel::-webkit-scrollbar-thumb,\nbody.dark_theme .puts-panel::-webkit-scrollbar-thumb {\n  background: #2b3139;\n}\n\n.strike-panel {\n  width: 120px;\n  flex-shrink: 0;\n  border-left: 1px solid #e2e8f04f;\n  border-right: 1px solid #e2e8f054;\n  background: #26292f;\n  z-index: 11;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.02);\n}\n\nbody.light_theme .strike-panel {\n  border-left: 1px solid #e2e8f0;\n  border-right: 1px solid #e2e8f0;\n  background: #fafafa;\n}\n\n.options-panel-inner {\n  display: flex;\n  flex-direction: column;\n  width: max-content;\n  min-width: 100%;\n}\n\n.calls-panel .options-sub-headers,\n.calls-panel .options-panel-row {\n  justify-content: space-between;\n}\n\n.puts-panel .options-sub-headers,\n.puts-panel .options-panel-row {\n  justify-content: space-between;\n}\n\n/* Row synchronization */\n.options-panel-row {\n  display: flex;\n  height: 48px;\n  border-bottom: 1px solid #f1f5f92b;\n  background: #26292f;\n\n}\n\nbody.light_theme .options-panel-row {\n  border-bottom: 1px solid #f1f5f9;\n  background: #fff;\n}\n\n.options-panel-row:hover {\n  background: #f1f5f921;\n}\n\nbody.light_theme .options-panel-row:hover {\n  background: #f1f5f9;\n}\n\n.options-panel-row.itm {\n  background: rgb(38 41 47);\n}\n\nbody.light_theme .options-panel-row.itm {\n  background: rgba(2, 192, 118, 0.05);\n}\n\n.options-strike-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 48px;\n  border-color: #2b3139;\n  color: #eaecef;\n  background: #26292f;\n  font-weight: 500;\n  font-size: 13px;\n\n}\n\nbody.light_theme .options-strike-cell {\n  border-bottom: 1px solid #f1f5f9;\n  color: #1e2329;\n  background: #fafafa;\n}\n\n.options-group-header-strike {\n  background: rgb(38 41 47) !important;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.295) !important;\n  border-top: 1px solid rgba(226, 232, 240, 0.432) !important;\n}\n\nbody.light_theme .options-group-header-strike {\n\n  background: rgb(248, 249, 250) !important;\n  border-bottom: 1px solid rgb(226, 232, 240);\n  border-top: 1px solid rgb(226, 232, 240);\n}\n\n.options-strike-sub {\n  font-size: 11px;\n  color: #848e9c;\n  font-weight: 400;\n}\n\n/* Headers */\n.options-panel-header-top {\n  display: flex;\n  align-items: center;\n  height: 44px;\n  background: #fafafa;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e2329;\n}\n\nbody.dark_theme .options-panel-header-top {\n  background: #1e2329;\n  color: #eaecef;\n  border-bottom-color: #2b3139;\n}\n\n.options-sub-headers {\n  display: flex;\n  align-items: center;\n  height: 36px;\n  border-bottom: none;\n  background: #26292f;\n}\n\nbody.light_theme .options-sub-headers {\n  background: #fcfcfc;\n}\n\n.agcex-opt-group-header {\n  padding: 8px 0;\n  background: #26292f;\n  border-bottom: 1px solid #e2e8f04a;\n  border-top: 1px solid #e2e8f033;\n  font-size: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\nbody.light_theme .agcex-opt-group-header {\n  background: #f8f9fa;\n  border-bottom: 1px solid #e2e8f0;\n  border-top: 1px solid #e2e8f0;\n}\n\n.agcex-opt-group-title {\n  position: sticky;\n  font-weight: bold;\n  z-index: 5;\n}\n\n.agcex-opt-group-title.left {\n  left: 16px;\n}\n\n.agcex-opt-group-title.right {\n  right: 16px;\n}\n\n.agcex-opt-group-info {\n  position: sticky;\n  color: #848e9c;\n  z-index: 5;\n}\n\n.agcex-opt-group-info.left {\n  left: 16px;\n}\n\n.agcex-opt-group-info.right {\n  right: 16px;\n}\n\n.agcex-opt-group-divider {\n  margin: 0 8px;\n}\n\nbody.dark_theme .options-sub-headers {\n  border-bottom-color: #2b3139;\n  background: #0b0e11;\n}\n\n.options-sub-header-cell {\n  flex: none;\n  padding: 0 4px;\n  width: 70px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #dedede;\n  text-align: left;\n  white-space: nowrap;\n}\n\nbody.light_theme .options-sub-header-cell {\n  color: #080808;\n}\n\n.options-sub-header-cell:first-child {\n  padding-left: 16px;\n}\n\n.options-sub-header-cell:last-child {\n  padding-right: 16px;\n}\n\nbody.dark_theme .options-sub-header-cell {\n  color: #848e9c;\n}\n\n/* Cells */\n.options-cell {\n  flex: none;\n  width: 70px;\n  padding: 0 4px;\n  font-size: 13px;\n  color: #dfdfdf;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  cursor: pointer;\n}\n\nbody.light_theme .options-cell {\n  color: #1e2329;\n}\n\n.options-cell:first-child {\n  padding-left: 16px;\n}\n\n.options-cell:last-child {\n  padding-right: 16px;\n}\n\nbody.dark_theme .options-cell {\n  color: #eaecef;\n}\n\n.options-cell.bid-ask:hover {\n  background: rgba(132, 142, 156, 0.1);\n}\n\n.options-cell-sub {\n  font-size: 11px;\n  color: #848e9c;\n  margin-top: 2px;\n}\n\n.fw-500 {\n  font-weight: 500 !important;\n}\n\n/* Forward Line in panels */\n.options-forward-line-half {\n  height: 24px;\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.options-forward-line-left,\n.options-forward-line-right {\n  height: 1px;\n  background: #e2e8f0;\n  width: 100%;\n}\n\nbody.dark_theme .options-forward-line-left,\nbody.dark_theme .options-forward-line-right {\n  background: #2b3139;\n}\n\n.options-forward-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #1e2329;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 4px;\n  height: 20px;\n  margin: 0 auto;\n}\n\nbody.dark_theme .options-forward-label {\n  background: #eaecef;\n  color: #1e2329;\n}\n\n/* --- Order Sidebar Modal --- */\n.options-order-sidebar {\n  position: fixed;\n  top: 0;\n  right: -400px;\n  width: 360px;\n  height: 100vh;\n  background: #fff;\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.1);\n  z-index: 10500;\n  transition: right 0.3s ease;\n  display: flex;\n  flex-direction: column;\n}\n\nbody.dark_theme .options-order-sidebar {\n  background: #1e2329;\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.5);\n}\n\n.options-order-sidebar.open {\n  right: 0;\n}\n\n.options-order-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\nbody.dark_theme .options-order-header {\n  border-bottom-color: #2b3139;\n}\n\n.options-order-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1e2329;\n}\n\nbody.dark_theme .options-order-title {\n  color: #eaecef;\n}\n\n.options-order-close {\n  background: transparent;\n  border: none;\n  font-size: 20px;\n  color: #848e9c;\n  cursor: pointer;\n}\n\n.options-order-close:hover {\n  color: #1e2329;\n}\n\nbody.dark_theme .options-order-close:hover {\n  color: #eaecef;\n}\n\n.options-order-body {\n  padding: 20px;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.options-order-toggle {\n  display: flex;\n  background: #f1f5f9;\n  border-radius: 6px;\n  padding: 2px;\n  margin-bottom: 16px;\n}\n\nbody.dark_theme .options-order-toggle {\n  background: #0b0e11;\n}\n\n.options-order-toggle-btn {\n  flex: 1;\n  background: transparent;\n  border: none;\n  padding: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #848e9c;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.options-order-toggle-btn.buy.active {\n  background: #02c076;\n  color: #fff;\n}\n\n.options-order-toggle-btn.sell.active {\n  background: #f84960;\n  color: #fff;\n}\n\n.options-order-field {\n  margin-bottom: 16px;\n}\n\n.options-order-label {\n  display: block;\n  font-size: 13px;\n  color: #474d57;\n  margin-bottom: 6px;\n  font-weight: 500;\n}\n\nbody.dark_theme .options-order-label {\n  color: #848e9c;\n}\n\n.options-order-input-wrapper {\n  display: flex;\n  align-items: center;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  padding: 0 12px;\n}\n\nbody.dark_theme .options-order-input-wrapper {\n  background: #0b0e11;\n  border-color: #2b3139;\n}\n\n.options-order-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  padding: 10px 0;\n  font-size: 14px;\n  color: #1e2329;\n  outline: none;\n}\n\nbody.dark_theme .options-order-input {\n  color: #eaecef;\n}\n\n.options-order-suffix {\n  font-size: 13px;\n  color: #848e9c;\n}\n\n.options-order-summary {\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px dashed #e2e8f0;\n}\n\nbody.dark_theme .options-order-summary {\n  border-top-color: #2b3139;\n}\n\n.options-order-summary-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  margin-bottom: 8px;\n}\n\n.options-order-summary-label {\n  color: #848e9c;\n}\n\n.options-order-summary-val {\n  color: #1e2329;\n  font-weight: 600;\n}\n\nbody.dark_theme .options-order-summary-val {\n  color: #eaecef;\n}\n\n.options-place-btn {\n  width: 100%;\n  padding: 12px;\n  border: none;\n  border-radius: 6px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #fff;\n  cursor: pointer;\n  margin-top: 24px;\n  transition: opacity 0.2s;\n}\n\n.options-place-btn.buy {\n  background: #02c076;\n}\n\n.options-place-btn.sell {\n  background: #f84960;\n}\n\n.options-place-btn:hover {\n  opacity: 0.9;\n}\n\n/* Backdrop */\n.options-sidebar-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 10400;\n  display: none;\n}\n\n.options-sidebar-backdrop.show {\n  display: block;\n}\n\n/* --- Recent Trades 24h Vol --- */\n.options-recent-trades-container {\n  display: flex;\n  gap: 4px;\n  padding: 4px 0px;\n  background: #26292f\n}\n\nbody.light_theme .options-recent-trades-container {\n  background: #f8f9fa;\n}\n\n.options-recent-trades-panel {\n  flex: 1 1;\n  background: #171a20;\n  border: none;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n}\n\nbody.light_theme .options-recent-trades-panel {\n  background: #fff;\n  border-color: #2b3139;\n}\n\n.options-recent-trades-header {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f3f3f31c;\n  font-weight: 600;\n  font-size: 14px;\n  color: #eaecef;\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n}\n\nbody.light_theme .options-recent-trades-header {\n  border-bottom-color: #f3f3f3;\n\n  color: #1e2329;\n}\n\n.options-recent-trades-vol {\n  font-size: 12px;\n  color: #848e9c;\n  font-weight: 400;\n}\n\n.options-recent-trades-body-wrap {\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n.options-recent-trades-body-wrap::-webkit-scrollbar {\n  width: 6px;\n}\n\n.options-recent-trades-body-wrap::-webkit-scrollbar-thumb {\n  background: #e2e8f0;\n  border-radius: 3px;\n}\n\nbody.dark_theme .options-recent-trades-body-wrap::-webkit-scrollbar-thumb {\n  background: #2b3139;\n}\n\n.options-recent-trades-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.options-recent-trades-table th {\n  position: sticky;\n  top: 0;\n  background: #171a20;\n  z-index: 2;\n  padding: 8px 16px;\n  text-align: right;\n  font-size: 12px;\n  color: #848e9c;\n  font-weight: 500;\n  border-bottom: 1px solid #f3f3f31c;\n  white-space: nowrap;\n}\n\nbody.light_theme .options-recent-trades-table th {\n  background: #fff;\n  border-bottom: 1px solid #f3f3f3;\n}\n\n.options-recent-trades-table th:first-child,\n.options-recent-trades-table td:first-child {\n  text-align: left;\n}\n\n.options-recent-trades-table td {\n  padding: 12px 16px;\n  text-align: right;\n  font-size: 12px;\n  color: #d9d9d9;\n  border-bottom: none;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\nbody.light_theme .options-recent-trades-table td {\n  color: #1e2329;\n  border-bottom-color: #1e2329;\n}\n\n/* --- Options Column Toggle Menu --- */\n.agcex-options-col-menu {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 12px;\n  z-index: 100;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  min-width: 160px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  color: #1e2329;\n  text-align: left;\n}\n\nbody.dark_theme .agcex-options-col-menu {\n  background: #1e2329;\n  border-color: #2b3139;\n  color: #eaecef;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);\n}\n\n.agcex-options-col-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.agcex-options-col-menu-icon {\n  font-size: 16px;\n  color: #d2d6de;\n}\n\nbody.dark_theme .agcex-options-col-menu-icon {\n  color: #474d57;\n}\n\n.agcex-options-col-menu-icon.checked {\n  color: #333b46;\n}\n\nbody.dark_theme .agcex-options-col-menu-icon.checked {\n  color: #eaecef;\n}\n\n.mid_lft_option {\n  min-width: 100%;\n  position: relative;\n}\n\n.mid_option_s.d-flex {\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.mid_right_option {\n  display: none;\n  background-color: #26292fd6;\n  width: 28%;\n  border-radius: 8px;\n  flex-direction: column;\n}\n\n.mid_right_option.is-open {\n  display: flex;\n}\n\nbody.light_theme .mid_right_option {\n  background-color: #ffffff;\n}\n\n.option-account-sidebar-rail {\n  width: 100%;\n  flex-shrink: 0;\n  border-top: 1px solid #2b3139;\n  background: #181a20;\n  border-radius: 0 0 8px 8px;\n}\n\nbody.light_theme .option-account-sidebar-rail {\n  border-top-color: #eaecef;\n  background: #fff;\n}\n\n.trade_account_summary_assets.trade-panel-open .trade_summary_table_lft {\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n}\n\n.assets_right.assets_panel_desktop.option_assetsright {\n  min-width: 19%;\n  max-width: 19%;\n  flex-shrink: 0;\n}\n\n/* --- New Sidebar Header --- */\n.agcex-new-sidebar-header {\n  padding: 16px;\n}\n\nbody.dark_theme .agcex-new-sidebar-header {\n  background: #26292f26;\n  border-left-color: #2b3139;\n}\n\n.agcex-nsh-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.agcex-nsh-title-area {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.agcex-nsh-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #eaecef;\n}\n\nbody.light_theme .agcex-nsh-title {\n  color: #1e2329;\n}\n\n.agcex-nsh-info {\n  color: #848e9c;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.agcex-nsh-collapse {\n  color: #848e9c;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.agcex-nsh-stats {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  border-top: 1px solid #f0f0f0;\n  padding-top: 12px;\n  overflow-x: auto;\n  gap: 15px;\n}\n\n.agcex-nsh-stats::-webkit-scrollbar {\n  display: none;\n}\n\nbody.dark_theme .agcex-nsh-stats {\n  border-top-color: #2b3139;\n}\n\n.agcex-nsh-stat-col {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 0 0 auto;\n}\n\n.agcex-nsh-stat-label {\n  color: #848e9c;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.agcex-nsh-stat-label .dotted-underline {\n  border-bottom: 1px dashed #848e9c;\n}\n\n.agcex-nsh-stat-val {\n  font-size: 13px;\n  font-weight: 600;\n  color: #eaecef;\n}\n\nbody.light_theme .agcex-nsh-stat-val {\n  color: #1e2329;\n}\n\n/* --- Options Orderbook & Form Layout --- */\n.agcex-options-trade-center {\n  display: flex;\n  width: 100%;\n}\n\n.agcex-opt-orderbook {\n  width: 100%;\n  flex: 1;\n  padding: 12px 8px;\n  background: #26292f26;\n}\n\n.agcex-opt-orderform {\n  width: 100%;\n  flex: 1;\n  padding: 12px;\n  background: #26292f26;\n}\n\nbody.light_theme .agcex-opt-orderbook {\n  background: #ffffff17;\n}\n\n\nbody.light_theme .agcex-opt-orderform {\n  background: #fff;\n}\n\n/* Orderbook styles mock */\n.agcex-opt-ob-filters {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 12px;\n  padding: 0 4px;\n}\n\n.agcex-opt-ob-filter-icon {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.agcex-opt-ob-table {\n  width: 100%;\n  font-size: 12px;\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n.agcex-opt-ob-table tr {\n  height: 22px;\n}\n\n.agcex-opt-ob-table th {\n  color: #848e9c;\n  font-weight: normal;\n  padding: 4px;\n  text-align: right;\n}\n\n.agcex-opt-ob-table th:first-child {\n  text-align: left;\n}\n\n.agcex-opt-ob-table td {\n  padding: 2px 4px;\n  text-align: right;\n}\n\n.agcex-opt-ob-table td:first-child {\n  text-align: left;\n}\n\n.agcex-opt-ob-price-red {\n  color: #f6465d;\n}\n\n.agcex-opt-ob-price-green {\n  color: #0ecb81;\n}\n\n.agcex-opt-ob-mid {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 12px;\n  margin: 8px 0;\n}\n\n.agcex-opt-ob-bar-wrap {\n  display: flex;\n  height: 4px;\n  width: 100%;\n  margin-top: 4px;\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.agcex-opt-ob-bar-green {\n  background-color: #0ecb81;\n  flex: 1;\n}\n\n.agcex-opt-ob-bar-red {\n  background-color: #f6465d;\n  flex: 1;\n}\n\n/* Order Form styles mock */\n.agcex-opt-form-tabs {\n  display: flex;\n  background: #F6F6F7;\n  border-radius: 4px;\n  margin-bottom: 12px;\n  overflow: hidden;\n}\n\nbody.dark_theme .agcex-opt-form-tabs {\n  background: #2b3139;\n}\n\n.agcex-opt-form-tab {\n  flex: 1 1;\n  text-align: center;\n  cursor: pointer;\n  color: #848e9c;\n  font-weight: 400;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 13px;\n}\n\n.agcex-opt-form-tab.buy.active {\n  background: #0ecb81;\n  color: #fff;\n}\n\n.agcex-opt-form-tab.sell.active {\n  background: #f6465d;\n  color: #fff;\n}\n\n.agcex-opt-form-subtabs {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 16px;\n  font-size: 13px;\n  color: #848e9c;\n}\n\n.agcex-opt-form-subtab {\n  cursor: pointer;\n  position: relative;\n  margin: 5px 0px;\n  padding-bottom: 8px;\n}\n\n.agcex-opt-form-subtab.active {\n  color: #1e2329;\n  font-weight: 600;\n}\n\n.agcex-opt-form-subtab.active::after {\n  position: absolute;\n  content: \" \";\n  min-width: 30px;\n  height: 3px;\n  border-radius: 10px;\n  background-color: #d1aa67;\n  bottom: 0px;\n  left: 50%;\n  transform: translateX(-50%) scaleX(.5);\n  /* opacity: 0; */\n  transition: all .16s ease-in;\n}\n\nbody.dark_theme .agcex-opt-form-subtab.active {\n  color: #eaecef;\n}\n\n.agcex-opt-input-group {\n  margin-bottom: 12px;\n}\n\n.agcex-opt-input-label {\n  font-size: 12px;\n  color: #848e9c;\n  margin-bottom: 4px;\n}\n\n.agcex-opt-input-wrap {\n  display: flex;\n  align-items: center;\n  background: #f5f5f512;\n  border-radius: 4px;\n  padding: 0 12px;\n  height: 40px;\n  border: 1px solid transparent;\n  transition: border-color 0.15s ease;\n}\n\nbody.light_theme .agcex-opt-input-wrap {\n  background: #f5f5f5;\n}\n\n.agcex-opt-input-wrap--error {\n  border-color: #f6465d;\n  background: #ffffff12;\n}\n\nbody.light_theme .agcex-opt-input-wrap--error {\n  border-color: #f6465d;\n  background: #fff;\n}\n\n.agcex-opt-price-band-msg {\n  margin: 6px 0 0;\n  font-size: 12px;\n  line-height: 1.35;\n  color: #f6465d;\n}\n\n.agcex-opt-form-error-msg {\n  margin: 0 0 10px;\n  font-size: 12px;\n  line-height: 1.35;\n  color: #f6465d;\n}\n\n.agcex-opt-submit-btn.is-disabled,\n.agcex-opt-submit-btn:disabled {\n  background-color: #d0d4db !important;\n  color: #fff;\n  cursor: not-allowed;\n  opacity: 1;\n}\n\nbody.dark_theme .agcex-opt-submit-btn.is-disabled,\nbody.dark_theme .agcex-opt-submit-btn:disabled {\n  background-color: #474d57 !important;\n  color: #848e9c;\n}\n\nbody.dark_theme .agcex-opt-input-wrap {\n  background: #2b3139;\n}\n\n.agcex-opt-input-wrap input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 14px;\n  color: #eaecef;\n}\n\nbody.light_theme .agcex-opt-input-wrap input {\n  color: #1e2329;\n}\n\n.agcex-opt-input-addon {\n  font-size: 13px;\n  color: #eaecef;\n  font-weight: 500;\n}\n\nbody.light_theme .agcex-opt-input-addon {\n  color: #1e2329;\n}\n\n.agcex-opt-transfer-icon--gold {\n  color: #d1aa67;\n}\n\n.agcex-opt-field-hint {\n  margin-left: 6px;\n  font-size: 11px;\n  color: #b7bdc6;\n  font-weight: 400;\n}\n\n.agcex-opt-avbl-row {\n  margin-bottom: 16px;\n}\n\n.agcex-opt-label-info {\n  font-size: 12px;\n  color: #848e9c;\n  vertical-align: middle;\n}\n\n.agcex-opt-iv-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #848e9c;\n  margin-bottom: 12px;\n}\n\n.agcex-opt-iv-row-val {\n  color: #eaecef;\n  font-weight: 500;\n  font-size: 13px;\n}\n\nbody.light_theme .agcex-opt-iv-row-val {\n  color: #1e2329;\n}\n\n.agcex-opt-input-wrap--amount input::placeholder {\n  color: #b7bdc6;\n  font-size: 13px;\n}\n\n.agcex-opt-pct-slider {\n  position: relative;\n  margin: 16px 0 20px;\n  padding: 0 2px;\n}\n\n.agcex-opt-pct-slider-track {\n  height: 2px;\n  background: #eaecef;\n  border-radius: 1px;\n}\n\nbody.dark_theme .agcex-opt-pct-slider-track {\n  background: #2b3139;\n}\n\n.agcex-opt-pct-slider-ticks {\n  display: flex;\n  justify-content: space-between;\n  margin-top: -6px;\n}\n\n.agcex-opt-pct-tick {\n  width: 10px;\n  height: 10px;\n  padding: 0;\n  border: 2px solid #eaecef;\n  background: #fff;\n  transform: rotate(45deg);\n  cursor: pointer;\n}\n\nbody.dark_theme .agcex-opt-pct-tick {\n  background: #181a20;\n  border-color: #474d57;\n}\n\n.agcex-opt-pct-tick.is-active {\n  border-color: #1e2329;\n  background: #fff;\n}\n\nbody.dark_theme .agcex-opt-pct-tick.is-active {\n  border-color: #eaecef;\n  background: #181a20;\n}\n\n.agcex-opt-tif-row,\n.agcex-opt-reduce-tif-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 13px;\n  color: #848e9c;\n  margin-bottom: 16px;\n}\n\n.agcex-opt-reduce-only {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0;\n  cursor: pointer;\n}\n\n.agcex-opt-reduce-only.is-locked {\n  cursor: default;\n  opacity: 0.9;\n}\n\n.agcex-opt-reduce-only.is-locked input {\n  cursor: not-allowed;\n}\n\n.agcex-opt-reduce-only-label {\n  border-bottom: 1px dotted #848e9c;\n}\n\n.agcex-opt-reduce-only input {\n  width: 14px;\n  height: 14px;\n  margin: 0;\n  accent-color: #1e2329;\n}\n\n.agcex-opt-tif-select {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin: 0;\n  cursor: pointer;\n  position: relative;\n}\n\n.agcex-opt-tif-value {\n  display: flex;\n  align-items: center;\n  color: #eaecef;\n  font-size: 13px;\n  font-weight: 500;\n  padding-right: 14px;\n  cursor: pointer;\n}\n\nbody.light_theme .agcex-opt-tif-value {\n  color: #1e2329;\n}\n\n.agcex-opt-tif-options {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin: 0;\n  padding: 4px 0;\n  list-style: none;\n  background: #2b3139;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n  z-index: 10;\n  min-width: 70px;\n}\n\nbody.light_theme .agcex-opt-tif-options {\n  background: #ffffff;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.agcex-opt-tif-options li {\n  padding: 8px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #eaecef;\n  cursor: pointer;\n  transition: background 0.2s;\n  text-align: left;\n}\n\nbody.light_theme .agcex-opt-tif-options li {\n  color: #1e2329;\n}\n\n.agcex-opt-tif-options li:hover,\n.agcex-opt-tif-options li.active {\n  background: #363c45;\n}\n\nbody.light_theme .agcex-opt-tif-options li:hover,\nbody.light_theme .agcex-opt-tif-options li.active {\n  background: #f3f4f6;\n}\n\n.agcex-opt-tif-select i {\n  position: absolute;\n  right: 0;\n  pointer-events: none;\n  font-size: 14px;\n  color: #848e9c;\n  transition: transform 0.2s;\n}\n\n.agcex-opt-tif-select i.open {\n  transform: rotate(180deg);\n}\n\n.agcex-opt-form-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #848e9c;\n}\n\n.agcex-opt-fee-rate-wrap {\n  position: relative;\n}\n\n.agcex-opt-fee-rate {\n  padding: 0;\n  border: none;\n  background: none;\n  font: inherit;\n  border-bottom: 1px dashed #848e9c;\n  cursor: pointer;\n  color: #848e9c;\n}\n\n.agcex-opt-fee-tooltip {\n  position: absolute;\n  right: 0;\n  bottom: calc(100% + 8px);\n  z-index: 30;\n  min-width: 240px;\n  padding: 12px 14px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n}\n\nbody:not(.light_theme) .agcex-opt-fee-tooltip {\n  background: #1e2329;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.45);\n}\n\n.agcex-opt-fee-tooltip-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e2329;\n  margin-bottom: 10px;\n}\n\nbody:not(.light_theme) .agcex-opt-fee-tooltip-title {\n  color: #eaecef;\n}\n\n.agcex-opt-fee-tooltip-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 12px;\n  color: #848e9c;\n  line-height: 1.5;\n}\n\n.agcex-opt-fee-tooltip-row+.agcex-opt-fee-tooltip-row {\n  margin-top: 6px;\n}\n\n.agcex-opt-fee-tooltip-row span:last-child {\n  color: #1e2329;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\nbody:not(.light_theme) .agcex-opt-fee-tooltip-row span:last-child {\n  color: #eaecef;\n}\n\n.agcex-opt-btn {\n  width: 100%;\n  background: #0ecb81;\n  color: #fff;\n  border: none;\n  border-radius: 50px !important;\n  padding: 11px 22px;\n  font-weight: 600;\n  font-size: 14px;\n  margin-top: 8px;\n}\n\n/* --- Inline Extraction for Orderbook --- */\n.agcex-opt-ob-filter-icon {\n  cursor: pointer;\n  padding-bottom: 2px;\n}\n\n.agcex-opt-ob-filter-icon svg {\n  opacity: 0.4;\n  transition: opacity 0.2s ease;\n}\n\n.agcex-opt-ob-filter-icon.active svg {\n  opacity: 1;\n}\n\n.agcex-opt-ob-scroll-250 {\n  height: 220px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.agcex-opt-ob-scroll-125 {\n  height: 110px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.agcex-opt-w-100 {\n  width: 100%;\n}\n\n.agcex-opt-w-25 {\n  width: 25%;\n}\n\n.agcex-text-left {\n  text-align: left;\n}\n\n.agcex-text-right {\n  text-align: right;\n}\n\n.agcex-text-center {\n  text-align: center;\n}\n\n.agcex-bg-red-light {\n  background: rgba(246, 70, 93, 0.1);\n}\n\n.agcex-bg-green-light {\n  background: rgba(14, 203, 129, 0.1);\n}\n\n.agcex-opt-ob-mid {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 4px;\n}\n\n.agcex-opt-ob-mid-empty {\n  color: #1e2329;\n  font-weight: bold;\n  font-size: 14px;\n}\n\nbody.dark_theme .agcex-opt-ob-mid-empty {\n  color: #eaecef;\n}\n\n.agcex-opt-ob-mid-price {\n  color: #d1aa67;\n  font-weight: 500;\n  font-size: 13px;\n  text-decoration: underline;\n  display: inline-block;\n  line-height: 1.2;\n  margin-bottom: 2px;\n}\n\n.agcex-opt-ob-mid-iv {\n  color: #848e9c;\n  font-size: 10px;\n  text-align: right;\n  line-height: 1;\n}\n\n.agcex-opt-ob-bar-flex-0 {\n  flex: 0;\n}\n\n.agcex-opt-ob-bar-flex-1 {\n  flex: 1;\n}\n\n.agcex-opt-ob-bar-divider {\n  width: 2px;\n  background: #fff;\n}\n\nbody.dark_theme .agcex-opt-ob-bar-divider {\n  background: #1e2329;\n}\n\n.agcex-opt-ob-stats {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.agcex-opt-trades-header {\n  font-weight: 600;\n  font-size: 14px;\n  margin: 16px 0 8px 0;\n}\n\n/* --- Contract Unit Modal --- */\n.agcex-opt-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgb(255 255 255 / 20%);\n  z-index: 9999999999;\n}\n\n.agcex-opt-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: #fff;\n  width: 530px;\n  max-width: 100%;\n  border-radius: 12px;\n  z-index: 99999999999;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n}\n\nbody.dark_theme .agcex-opt-modal {\n  background: #1e2329;\n}\n\n.agcex-opt-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 24px 16px;\n}\n\n.agcex-opt-modal-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1e2329;\n}\n\nbody.dark_theme .agcex-opt-modal-title {\n  color: #eaecef;\n}\n\n.agcex-opt-modal-close {\n  font-size: 24px;\n  color: #848e9c;\n  cursor: pointer;\n}\n\n.agcex-opt-modal-close:hover {\n  color: #1e2329;\n}\n\nbody.dark_theme .agcex-opt-modal-close:hover {\n  color: #eaecef;\n}\n\n.agcex-opt-modal-body {\n  padding: 0 24px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.agcex-opt-modal-option {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 16px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\nbody.dark_theme .agcex-opt-modal-option {\n  border-color: #2b3139;\n}\n\n.agcex-opt-modal-option.active {\n  border-color: #1e2329;\n}\n\nbody.dark_theme .agcex-opt-modal-option.active {\n  border-color: #fcd535;\n}\n\n.agcex-opt-modal-option-title {\n  font-size: 15px;\n  font-weight: 500;\n  color: #1e2329;\n  margin-bottom: 4px;\n}\n\nbody.dark_theme .agcex-opt-modal-option-title {\n  color: #eaecef;\n}\n\n.agcex-opt-modal-option-desc {\n  font-size: 13px;\n  color: #848e9c;\n}\n\n.agcex-opt-modal-footer {\n  padding: 0 24px 24px;\n}\n\n.agcex-opt-modal-btn {\n  width: 100%;\n  background: #1e2329;\n  color: #fff;\n  border: none;\n  padding: 12px;\n  border-radius: 50px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\nbody.dark_theme .agcex-opt-modal-btn {\n  background: #fcd535;\n  color: #1e2329;\n}\n\n.agcex-opt-modal-btn.disabled {\n  color: #b7bdc6;\n  background: #f8f9fa;\n  cursor: not-allowed;\n}\n\nbody.dark_theme .agcex-opt-modal-btn.disabled {\n  background: #2b3139;\n  color: #474d57;\n}\n\n/* --- Options Chart Tabs (PnL, Mark, Index) --- */\n.agcex-opt-chart-tabs-container {\n  margin-top: 16px;\n  border-top: 1px solid #e2e8f0;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\nbody.dark_theme .agcex-opt-chart-tabs-container {\n  background: #1e2329;\n  border-color: #2b3139;\n}\n\n.agcex-opt-chart-tabs-header {\n  display: flex;\n  flex-wrap: nowrap;\n  border-bottom: 1px solid #e2e8f0;\n  padding: 0 16px;\n  overflow-x: auto;\n  white-space: nowrap;\n}\n\nbody.dark_theme .agcex-opt-chart-tabs-header {\n  border-color: #2b3139;\n}\n\n.agcex-opt-chart-tab {\n  padding: 12px 0;\n  margin-right: 16px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #848e9c;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.agcex-opt-chart-tab.active::after {\n  position: absolute;\n  content: \" \";\n  min-width: 40px;\n  height: 3px;\n  border-radius: 10px;\n  background-color: #d1aa67;\n  bottom: -2px;\n  left: 50%;\n  transform: translateX(-50%) scaleX(.5);\n  /* opacity: 0; */\n  transition: all .16s ease-in;\n}\n\n.agcex-opt-chart-tab.active {\n  font-weight: 600;\n  color: #1e2329;\n}\n\nbody.dark_theme .agcex-opt-chart-tab.active {\n  color: #eaecef;\n  border-bottom-color: #fcd535;\n}\n\n.agcex-opt-chart-refresh {\n  display: flex;\n  align-items: center;\n  color: #848e9c;\n  cursor: pointer;\n}\n\n.agcex-opt-chart-refresh:hover {\n  color: #1e2329;\n}\n\nbody.dark_theme .agcex-opt-chart-refresh:hover {\n  color: #eaecef;\n}\n\n.agcex-opt-chart-body {\n  padding: 16px;\n  min-height: 340px;\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n}\n\n/* PNL specific */\n.agcex-opt-chart-pnl-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.agcex-opt-chart-pnl-legend {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  font-size: 13px;\n  color: #1e2329;\n}\n\nbody.dark_theme .agcex-opt-chart-pnl-legend {\n  color: #eaecef;\n}\n\n.agcex-opt-chart-pnl-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.agcex-opt-chart-pnl-controls {\n  display: flex;\n  background: #f5f5f5;\n  border-radius: 4px;\n  padding: 2px;\n}\n\nbody.dark_theme .agcex-opt-chart-pnl-controls {\n  background: #2b3139;\n}\n\n.agcex-opt-chart-pnl-iv {\n  padding: 2px 8px;\n  font-size: 12px;\n  color: #1e2329;\n  border-right: 1px solid #d9d9d9;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\nbody.dark_theme .agcex-opt-chart-pnl-iv {\n  color: #eaecef;\n  border-bottom-color: #eaecef;\n}\n\n.agcex-opt-chart-pnl-mark {\n  padding: 2px 8px;\n  font-size: 12px;\n  color: #1e2329;\n  /* background: #fff; */\n  /* border-radius: 2px; */\n  /* box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05); */\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\nbody.dark_theme .agcex-opt-chart-pnl-mark {\n  background: #1e2329;\n  color: #eaecef;\n}\n\n.agcex-opt-chart-pnl-slider-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.agcex-opt-chart-pnl-badge {\n  background: #f5f5f5;\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #848e9c;\n}\n\nbody.dark_theme .agcex-opt-chart-pnl-badge {\n  background: #2b3139;\n}\n\n.agcex-opt-chart-pnl-slider {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  color: #1e2329;\n}\n\nbody.dark_theme .agcex-opt-chart-pnl-slider {\n  color: #eaecef;\n}\n\n.agcex-opt-chart-pnl-graph {\n  flex: 1;\n  position: relative;\n  min-height: 220px;\n  margin-left: 32px;\n  margin-bottom: 24px;\n  border-left: 1px dashed #e2e8f0;\n  border-bottom: 1px dashed #e2e8f0;\n  display: flex;\n  align-items: flex-end;\n}\n\nbody.dark_theme .agcex-opt-chart-pnl-graph {\n  border-color: #2b3139;\n}\n\n.agcex-opt-chart-pnl-y-axis {\n  position: absolute;\n  left: -32px;\n  top: 0;\n  bottom: 32px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #848e9c;\n  padding-right: 8px;\n  text-align: right;\n  width: 32px;\n}\n\n.agcex-opt-chart-pnl-x-axis {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -24px;\n  display: flex;\n  justify-content: space-between;\n  font-size: 10px;\n  color: #848e9c;\n}\n\n.agcex-opt-chart-pnl-grid-line {\n  position: absolute;\n  left: 0;\n  right: 0;\n  border-top: 1px dashed #e2e8f0;\n  z-index: 1;\n}\n\nbody.dark_theme .agcex-opt-chart-pnl-grid-line {\n  border-color: #2b3139;\n}\n\n.agcex-opt-chart-pnl-marker {\n  position: absolute;\n  left: 85%;\n  top: 10%;\n  bottom: 0;\n  border-left: 1px dashed #848e9c;\n  z-index: 2;\n}\n\n.agcex-opt-chart-pnl-marker-label {\n  position: absolute;\n  top: -20px;\n  left: -30px;\n  font-size: 12px;\n  color: #1e2329;\n  white-space: nowrap;\n}\n\nbody.dark_theme .agcex-opt-chart-pnl-marker-label {\n  color: #eaecef;\n}\n\n.agcex-opt-chart-pnl-bottom-slider {\n  position: absolute;\n  bottom: -50px;\n  left: 0;\n  right: 0;\n}\n\n/* Candlestick specific */\n.agcex-opt-chart-timeframes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  font-size: 12px;\n  color: #848e9c;\n  margin-bottom: 16px;\n}\n\n.agcex-opt-chart-tf-item {\n  cursor: pointer;\n}\n\n.agcex-opt-chart-tf-item:hover {\n  color: #1e2329;\n}\n\nbody.dark_theme .agcex-opt-chart-tf-item:hover {\n  color: #eaecef;\n}\n\n.agcex-opt-chart-tf-item.active {\n  color: #1e2329;\n  font-weight: 600;\n  background: #f5f5f5;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\nbody.dark_theme .agcex-opt-chart-tf-item.active {\n  color: #eaecef;\n  background: #2b3139;\n}\n\n.agcex-opt-chart-legend-row {\n  font-size: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.agcex-opt-chart-ma-row {\n  font-size: 12px;\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.agcex-opt-chart-placeholder {\n  flex: 1;\n  min-height: 230px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fafafa;\n  border-radius: 4px;\n}\n\nbody.dark_theme .agcex-opt-chart-placeholder {\n  background: #181a20;\n}\n\n.agcex-opt-chart-y-axis {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  border-left: 1px dashed #e2e8f0;\n  width: 50px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-end;\n  padding-right: 4px;\n  font-size: 10px;\n  color: #848e9c;\n}\n\n/* --- Options Order Form Inline Styles Replacement --- */\n.agcex-opt-form-info-icon {\n  margin-left: auto;\n  cursor: pointer;\n  color: #848e9c;\n}\n\nbody.dark_theme .agcex-opt-form-info-icon {\n  color: #eaecef;\n}\n\n.agcex-opt-exec-type-wrap {\n  cursor: pointer;\n}\n\n.agcex-opt-exec-type-text {\n  flex: 1;\n  font-size: 14px;\n  color: #1e2329;\n  font-weight: 500;\n}\n\nbody.dark_theme .agcex-opt-exec-type-text {\n  color: #eaecef;\n}\n\n.agcex-opt-input-group-price {\n  margin-bottom: 4px;\n}\n\n.agcex-opt-input-wrap.no-pad-right {\n  padding-right: 0;\n}\n\n.agcex-opt-input-last-price {\n  color: #111111;\n  font-size: 14px;\n  font-weight: 500;\n  margin-right: 8px;\n  padding: 0 8px;\n  cursor: pointer;\n}\n\nbody.dark_theme .agcex-opt-input-last-price {\n  color: #5c8dff;\n}\n\n.agcex-opt-input-percent {\n  padding: 0 12px;\n  color: inherit;\n  font-weight: 500;\n}\n\n.agcex-opt-iv-text-alt {\n  color: #848e9c;\n  font-size: 12px;\n}\n\n.agcex-opt-input-stepper {\n  display: flex;\n  flex-direction: column;\n  border-left: 1px solid #e2e8f0;\n  background: #f8f9fa;\n  width: 24px;\n  height: 40px;\n}\n\nbody.dark_theme .agcex-opt-input-stepper {\n  border-left-color: #2b3139;\n  background: #181a20;\n}\n\n.agcex-opt-stepper-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.agcex-opt-stepper-btn.border-bot {\n  border-bottom: 1px solid #e2e8f0;\n}\n\nbody.dark_theme .agcex-opt-stepper-btn.border-bot {\n  border-bottom-color: #2b3139;\n}\n\n.agcex-opt-stepper-icon {\n  font-size: 12px;\n  color: #848e9c;\n}\n\nbody.dark_theme .agcex-opt-stepper-icon {\n  color: #b7bdc6;\n}\n\n.agcex-opt-iv-text {\n  font-size: 12px;\n  color: #848e9c;\n  margin-top: 4px;\n}\n\n.agcex-opt-iv-label {\n  border-bottom: 1px dashed #848e9c;\n  cursor: pointer;\n}\n\n.agcex-opt-input-unit {\n  color: #1e2329;\n  font-size: 14px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n}\n\nbody.dark_theme .agcex-opt-input-unit {\n  color: #eaecef;\n}\n\n.agcex-opt-position-details {\n  display: flex;\n  justify-content: space-between;\n  padding: 7px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #848e9c;\n  margin-bottom: 14px;\n}\n\nbody.dark_theme .agcex-opt-position-details {\n  border-color: #2b3139;\n}\n\n.agcex-opt-position-val {\n  color: #1e2329;\n  font-weight: 500;\n}\n\nbody.dark_theme .agcex-opt-position-val {\n  color: #eaecef;\n}\n\n.agcex-opt-form-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  color: #848e9c;\n  margin-bottom: 12px;\n}\n\n.agcex-opt-form-row.mb-16 {\n  margin-bottom: 16px;\n}\n\n.agcex-opt-form-row.mb-0 {\n  margin-bottom: 0px;\n}\n\n.agcex-opt-form-val {\n  color: #eaecef;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\nbody.light_theme .agcex-opt-form-val {\n\n  color: #1e2329;\n}\n\n.agcex-opt-transfer-icon {\n  color: #eaecef;\n  font-size: 16px;\n  cursor: pointer;\n}\n\nbody.light_theme .agcex-opt-transfer-icon {\n  color: #1e2329;\n}\n\n.agcex-opt-submit-btn {\n  border-radius: 24px;\n  padding: 9px 12px;\n  font-size: 14px;\n  margin-bottom: 16px;\n  width: 100%;\n  color: #fff;\n  border: none;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.agcex-opt-submit-btn.buy {\n  background-color: #2ebd85;\n}\n\n.agcex-opt-submit-btn.sell {\n  background-color: #f6465d;\n}\n\na.agcex-opt-submit-btn.agcex-opt-submit-btn--kyc {\n  display: block;\n  text-align: center;\n  text-decoration: none;\n  color: #fff !important;\n}\n\na.agcex-opt-submit-btn.agcex-opt-submit-btn--kyc:hover {\n  color: #fff !important;\n  opacity: 0.92;\n}\n\nbody.dark_theme .agcex-opt-chart-y-axis {\n  border-color: #2b3139;\n}\n\n/* --- Options Row Selection --- */\n.options-panel-row.selected {\n  border: 1px solid #1111112e;\n  background-color: #ffffff24;\n}\n\n\nbody.light_theme .options-panel-row.selected {\n  border-top-color: #eaecef !important;\n  border-bottom-color: #eaecef !important;\n  background-color: #fff;\n}\n\n.options-row-close-btn {\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  right: 0;\n  width: 24px;\n  background: #111;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 10;\n  font-size: 14px;\n}\n\nbody.dark_theme .options-row-close-btn {\n  background: #eaecef;\n  color: #111;\n}\n\n.options-row-close-btn.puts-close {\n  right: auto;\n  left: 0;\n}\n\n.agcex-opt-chart-x-axis {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  border-top: 1px dashed #e2e8f0;\n  height: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 4px;\n  font-size: 10px;\n  color: #848e9c;\n}\n\nbody.dark_theme .agcex-opt-chart-x-axis {\n  border-top-color: #2b3139;\n}\n\n/* --- Disable Horizontal Scroll on Selection --- */\n\n.agcex-nsh-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.trade-panel-open .mid_lft_option {\n  min-width: 71.7%;\n}\n\n.agcex-nsh-tabs {\n  display: flex;\n  background: #f4f5f6;\n  border-radius: 6px;\n  padding: 2px;\n}\n\nbody.dark_theme .agcex-nsh-tabs {\n  background: #2b3139;\n}\n\n.agcex-nsh-tab {\n  padding: 4px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #848e9c;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.agcex-nsh-tab.active {\n  background: #fff;\n  color: #1e2329;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\nbody.dark_theme .agcex-nsh-tab.active {\n  background: #1e2329;\n  color: #eaecef;\n}\n\n.agcex-opt-chart-current-price {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 75%;\n  border-top: 1px dashed #f6465d;\n  z-index: 1;\n}\n\n.agcex-opt-chart-current-price-label {\n  position: absolute;\n  right: 0;\n  top: -10px;\n  background: #f6465d;\n  color: #fff;\n  font-size: 10px;\n  padding: 2px 4px;\n  border-radius: 2px;\n}\n\n/* --- Recurring Sell Panel --- */\n.agcex-recurring-sell-panel {\n  padding: 16px;\n  border-top: 1px solid #f0f0f0;\n}\n\nbody.dark_theme .agcex-recurring-sell-panel {\n  border-top-color: #2b3139;\n}\n\n.rs-toggle-group {\n  display: flex;\n  background: #f4f5f6;\n  border-radius: 6px;\n  padding: 2px;\n  margin-bottom: 24px;\n}\n\nbody.dark_theme .rs-toggle-group {\n  background: #2b3139;\n}\n\n.rs-toggle-btn {\n  flex: 1;\n  text-align: center;\n  padding: 8px 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #848e9c;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.rs-toggle-btn.active-call {\n  background: #2ebd85;\n  color: #fff;\n}\n\n.rs-toggle-btn.active-put {\n  background: #f6465d;\n  color: #fff;\n}\n\n.rs-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 32px;\n}\n\n.rs-col-left,\n.rs-col-right {\n  display: flex;\n  flex-direction: column;\n}\n\n.rs-section-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1e2329;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n}\n\nbody.dark_theme .rs-section-title {\n  color: #eaecef;\n}\n\n.rs-form-group {\n  margin-bottom: 16px;\n}\n\n.rs-form-group label {\n  display: block;\n  font-size: 13px;\n  margin-bottom: 8px;\n}\n\n.rs-label-light {\n  color: #848e9c;\n}\n\n.rs-dotted-label {\n  color: #848e9c;\n  border-bottom: 1px dashed #848e9c;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.rs-dotted-label-white {\n  color: #fff;\n  border-bottom: 1px dashed rgba(255, 255, 255, 0.7);\n  display: inline-block;\n}\n\n.rs-segment-group {\n  display: flex;\n  gap: 8px;\n}\n\n.rs-segment-btn {\n  flex: 1;\n  background: #f4f5f6;\n  text-align: center;\n  padding: 6px 0;\n  border-radius: 4px;\n  font-size: 13px;\n  color: #1e2329;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n\nbody.dark_theme .rs-segment-btn {\n  background: #2b3139;\n  color: #eaecef;\n}\n\n.rs-segment-btn.active {\n  background: #fff;\n  border-color: #111;\n  font-weight: 500;\n}\n\nbody.dark_theme .rs-segment-btn.active {\n  background: #181a20;\n  border-color: #eaecef;\n}\n\n.rs-delta-input-row {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n}\n\n.rs-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.rs-input {\n  width: 100%;\n  background: #f4f5f6;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 4px;\n  color: #1e2329;\n  font-size: 14px;\n  font-weight: 500;\n  outline: none;\n}\n\nbody.dark_theme .rs-input {\n  background: #2b3139;\n  color: #eaecef;\n}\n\n.rs-delta-val {\n  flex: 1;\n}\n\n.rs-strike-toggle {\n  background: #f4f5f6;\n  border-radius: 4px;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #1e2329;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  line-height: 1.2;\n  cursor: pointer;\n}\n\nbody.dark_theme .rs-strike-toggle {\n  background: #2b3139;\n  color: #eaecef;\n}\n\n.rs-slider-container {\n  margin-top: 12px;\n}\n\n.rs-slider {\n  width: 100%;\n  -webkit-appearance: none;\n  background: transparent;\n}\n\n.rs-slider::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 4px;\n  cursor: pointer;\n  background: #e2e8f0;\n  border-radius: 2px;\n}\n\nbody.dark_theme .rs-slider::-webkit-slider-runnable-track {\n  background: #2b3139;\n}\n\n.rs-slider::-webkit-slider-thumb {\n  border: 2px solid #111;\n  height: 12px;\n  width: 12px;\n  border-radius: 50%;\n  background: #fff;\n  cursor: pointer;\n  -webkit-appearance: none;\n  margin-top: -4px;\n}\n\nbody.dark_theme .rs-slider::-webkit-slider-thumb {\n  border-color: #eaecef;\n}\n\n.rs-slider-labels {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  color: #848e9c;\n  margin-top: 4px;\n}\n\n.rs-suffix {\n  position: absolute;\n  right: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e2329;\n}\n\nbody.dark_theme .rs-suffix {\n  color: #eaecef;\n}\n\n.rs-input-wrapper.sellamount_btc input.rs-input {\n  padding-right: 52px;\n}\n\n.rs-dropdown {\n  background: #f4f5f6;\n  border-radius: 4px;\n  padding: 8px 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 500;\n  color: #1e2329;\n  cursor: pointer;\n}\n\nbody.dark_theme .rs-dropdown {\n  background: #2b3139;\n  color: #eaecef;\n}\n\n.rs-flex-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 13px;\n}\n\n.rs-val-dark {\n  color: #1e2329;\n  font-weight: 600;\n}\n\nbody.dark_theme .rs-val-dark {\n  color: #eaecef;\n}\n\n.rs-val-dotted {\n  color: #1e2329;\n  font-weight: 600;\n  border-bottom: 1px dashed #1e2329;\n}\n\nbody.dark_theme .rs-val-dotted {\n  color: #eaecef;\n  border-bottom-color: #eaecef;\n}\n\n.rs-preview-btn {\n  width: 100%;\n  background: #f4f5f6;\n  color: #1e2329;\n  font-weight: 600;\n  font-size: 14px;\n  padding: 12px;\n  border: none;\n  border-radius: 24px;\n  margin-top: 24px;\n  cursor: pointer;\n}\n\nbody.dark_theme .rs-preview-btn {\n  background: #2b3139;\n  color: #eaecef;\n}\n\n.rs-risk-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\nbody.dark_theme .rs-risk-card {\n  border-color: #2b3139;\n}\n\n.rs-risk-card-header {\n  padding: 12px 16px 5px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\nbody.dark_theme .rs-risk-card-header {\n  border-bottom-color: #2b3139;\n}\n\n.rs-risk-card-header .rs-dotted-label {\n  color: #1e2329;\n  font-weight: 500;\n  font-size: 12px;\n  border-bottom: none;\n}\n\nbody.dark_theme .rs-risk-card-header .rs-dotted-label {\n  color: #eaecef;\n}\n\n.rs-risk-card-body {\n  padding: 16px;\n}\n\n.rs-summary-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n  padding: 15px;\n  margin-bottom: 16px;\n}\n\nbody.dark_theme .rs-summary-card {\n  border-color: #2b3139;\n}\n\n.rs-risk-level-banner {\n  background: #D1AA67;\n  padding: 6px 12px;\n  display: flex;\n  font-size: 13px;\n  gap: 7px;\n  justify-content: center;\n  border-radius: 50px;\n  align-items: center;\n}\n\n.rs-risk-level-banner .rs-dotted-label-white {\n  display: inline-flex;\n}\n\n.rs-risk-badge {\n  color: #fff;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.rs-win-rate-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 0px 0px;\n  font-size: 12px;\n}\n\nbody.dark_theme .rs-win-rate-row {\n  background: #181a20;\n}\n\n.rs-win-rate-val {\n  color: #2ebd85;\n  font-weight: 600;\n}\n\n.rs-create-btn {\n  width: 100%;\n  background: #1e2329;\n  color: #fff;\n  font-weight: 600;\n  font-size: 14px;\n  padding: 10px;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n}\n\nbody.dark_theme .rs-create-btn {\n  background: #eaecef;\n  color: #111;\n}\n\n.trade_summary_table_lft table tr {\n  border-left: 0px !important;\n}\n\n.rs-dropdown-menu {\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  padding: 8px 0;\n  margin-bottom: 4px;\n}\n\nbody.dark_theme .rs-dropdown-menu {\n  background: #181a20;\n  border-color: #2b3139;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);\n}\n\n.rs-dropdown-item {\n  padding: 10px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #1e2329;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\nbody.dark_theme .rs-dropdown-item {\n  color: #eaecef;\n}\n\n.rs-dropdown-item:hover {\n  background: #f4f5f6;\n}\n\nbody.dark_theme .rs-dropdown-item:hover {\n  background: #2b3139;\n}\n\n.rs-dropdown-item .ri-checkbox-circle-fill {\n  color: #1e2329;\n  font-size: 16px;\n}\n\nbody.dark_theme .rs-dropdown-item .ri-checkbox-circle-fill {\n  color: #eaecef;\n}\n\n/* Tickers Bar Redesign */\n.options-tickers-bar {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 8px 16px;\n\n  background: #ffffff0f;\n  border-bottom: 1px solid #e2e8f03d;\n}\n\nbody.light_theme .options-tickers-bar {\n\n  background: #fff;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.hdr_lft_list {\n  flex: 1;\n  min-width: 0;\n}\n\nbody.dark_theme .options-tickers-bar {\n  background: #181a20;\n  border-bottom-color: #2b3139;\n}\n\n.options-tickers-scroll {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex: 1;\n}\n\n.options-tickers-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.options-scroll-arrow {\n  background: none;\n  border: none;\n  font-size: 18px;\n  color: #848e9c;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 0px;\n  flex-shrink: 0;\n  transition: all 0.2s;\n}\n\nbody.dark_theme .options-scroll-arrow {\n  background: #2b3139;\n}\n\n/* .options-scroll-arrow:hover {\n  color: #1e2329;\n  background: #e2e8f0;\n} */\n\nbody.dark_theme .options-scroll-arrow:hover {\n  color: #eaecef;\n  background: #363c45;\n}\n\n.options-ticker-active-block {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.options-ticker-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  border-radius: 8px;\n  padding: 6px 10px;\n  min-width: 134px;\n  border: 1px solid #e2e8f014;\n  background: #f8f9fa12;\n  flex-shrink: 0;\n}\n\nbody.light_theme .options-ticker-item {\n  border: 1px solid #e2e8f0;\n  background: #f8f9fa;\n}\n\n/* .options-ticker-item:hover {\n  background: #f1f5f9;\n} */\n\n.options-ticker-item.active {\n  border: 1px solid #e2e8f01c;\n  background: #f8f9fa36;\n}\n\n.options-ticker-bottom {\n  font-size: 12px;\n  line-height: 1.2;\n  margin-top: 2px;\n}\n\n.options-ticker-price {\n  font-weight: 600;\n  color: #bdbdbd;\n}\n\nbody.light_theme .options-ticker-price {\n  color: #474d57;\n}\n\n.options-ticker-info-wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  line-height: 1;\n}\n\n.options-ticker-info-icon {\n  font-size: 14px;\n  color: #b7bdc6;\n  cursor: help;\n}\n\n.options-ticker-info-icon:hover {\n  color: #848e9c;\n}\n\n.options-ticker-info-tip {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 50;\n  width: 260px;\n  padding: 12px 14px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  pointer-events: none;\n}\n\nbody.dark_theme .options-ticker-info-tip {\n  background: #1e2329;\n  border-color: #2b3139;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);\n}\n\n.options-ticker-info-tip__title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e2329;\n  margin-bottom: 6px;\n}\n\nbody.dark_theme .options-ticker-info-tip__title {\n  color: #eaecef;\n}\n\n.options-ticker-info-tip__text {\n  margin: 0 0 10px;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #848e9c;\n  white-space: normal;\n}\n\n.options-ticker-info-tip__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 12px;\n  color: #848e9c;\n}\n\n.options-ticker-info-tip__row+.options-ticker-info-tip__row {\n  margin-top: 6px;\n}\n\n.options-ticker-info-tip__row span:last-child {\n  color: #1e2329;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\nbody.dark_theme .options-ticker-info-tip__row span:last-child {\n  color: #eaecef;\n}\n\n.options-ticker-coin-img {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.options-ticker-info {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.options-ticker-top {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.options-ticker-symbol {\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n}\n\nbody.light_theme .options-ticker-symbol {\n  color: #1e2329;\n}\n\n.options-ticker-arrow {\n  color: #848e9c;\n  font-size: 16px;\n}\n\n.options-ticker-scm-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: #f4f5f6;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1e2329;\n  cursor: pointer;\n}\n\nbody.dark_theme .options-ticker-scm-btn {\n  background: #2b3139;\n  color: #eaecef;\n}\n\n.options-ticker-margin-block {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  padding-left: 20px;\n  border-left: 1px solid #e2e8f0;\n}\n\nbody.dark_theme .options-ticker-margin-block {\n  border-left-color: #2b3139;\n}\n\n.margin-col {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.margin-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n}\n\n.margin-label {\n  color: #eaecef;\n  font-weight: 600;\n}\n\nbody.light_theme .margin-label {\n  color: #1e2329;\n}\n\n.margin-label.dotted {\n  border-bottom: 1px dashed #b7bdc6;\n  cursor: pointer;\n}\n\n.margin-val {\n  font-weight: 600;\n}\n\n.margin-val.text-green {\n  color: #2ebd85;\n}\n\n.margin-progress {\n  width: 40px;\n  height: 4px;\n  background: #e2e8f0;\n  border-radius: 2px;\n  overflow: hidden;\n}\n\nbody.dark_theme .margin-progress {\n  background: #2b3139;\n}\n\n.progress-fill {\n  height: 100%;\n  background: #b7bdc6;\n}\n\n/* Switch Account Mode Modal Styles */\n.agcx-accmode-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1050;\n}\n\n.agcx-accmode-modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 420px;\n  height: 100vh;\n  background: #ffffff;\n  z-index: 9999999;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.1);\n  font-family: inherit;\n}\n\nbody.dark_theme .agcx-accmode-modal {\n  background: #181a20;\n  color: #eaecef;\n}\n\n.agcx-accmode-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\nbody.dark_theme .agcx-accmode-header {\n  border-bottom-color: #2b3139;\n}\n\n.agcx-accmode-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1e2329;\n}\n\nbody.dark_theme .agcx-accmode-title {\n  color: #eaecef;\n}\n\n.agcx-accmode-title i.ri-arrow-left-s-line {\n  font-size: 24px;\n  cursor: pointer;\n  color: #1e2329;\n}\n\nbody.dark_theme .agcx-accmode-title i.ri-arrow-left-s-line {\n  color: #eaecef;\n}\n\n.agcx-accmode-help {\n  font-size: 16px;\n  color: #848e9c;\n  cursor: pointer;\n}\n\n.agcx-accmode-history {\n  font-size: 20px;\n  color: #848e9c;\n  cursor: pointer;\n}\n\n.agcx-accmode-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.agcx-accmode-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\nbody.dark_theme .agcx-accmode-card {\n  border-color: #2b3139;\n  background: #181a20;\n}\n\n.agcx-accmode-card.active {\n  border-color: #1e2329;\n  box-shadow: 0 0 0 1px #1e2329;\n}\n\nbody.dark_theme .agcx-accmode-card.active {\n  border-color: #f0b90b;\n  box-shadow: 0 0 0 1px #f0b90b;\n}\n\n.agcx-accmode-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n\n.agcx-accmode-card-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1e2329;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\nbody.dark_theme .agcx-accmode-card-title {\n  color: #eaecef;\n}\n\n.badge-gray {\n  background: #f4f5f6;\n  color: #848e9c;\n  font-size: 11px;\n  font-weight: 500;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\nbody.dark_theme .badge-gray {\n  background: #2b3139;\n}\n\n.active-icon {\n  font-size: 18px;\n  color: #1e2329;\n}\n\nbody.dark_theme .active-icon {\n  color: #f0b90b;\n}\n\n.agcx-accmode-card-desc {\n  font-size: 13px;\n  color: #707a8a;\n  margin-bottom: 12px;\n}\n\n.agcx-accmode-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 16px;\n}\n\n.agcx-accmode-tags span {\n  background: #f4f5f6;\n  color: #707a8a;\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\nbody.dark_theme .agcx-accmode-tags span {\n  background: #2b3139;\n  color: #848e9c;\n}\n\n.agcx-accmode-showmore {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  color: #848e9c;\n  cursor: pointer;\n  margin-top: 8px;\n}\n\n.agcx-accmode-showmore:hover {\n  color: #1e2329;\n}\n\nbody.dark_theme .agcx-accmode-showmore:hover {\n  color: #eaecef;\n}\n\n.agcx-accmode-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 0;\n  border-top: 1px solid #e2e8f0;\n  font-size: 13px;\n  color: #1e2329;\n  font-weight: 500;\n}\n\nbody.dark_theme .agcx-accmode-toggle-row {\n  border-top-color: #2b3139;\n  color: #eaecef;\n}\n\n/* Switch Styles */\n.agcx-toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 36px;\n  height: 20px;\n}\n\n.agcx-toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.agcx-toggle-switch .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: .4s;\n}\n\n.agcx-toggle-switch .slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  transition: .4s;\n}\n\n.agcx-toggle-switch input:checked+.slider {\n  background-color: #2ebd85;\n}\n\n.agcx-toggle-switch input:checked+.slider:before {\n  transform: translateX(16px);\n}\n\n.agcx-toggle-switch .slider.round {\n  border-radius: 20px;\n}\n\n.agcx-toggle-switch .slider.round:before {\n  border-radius: 50%;\n}\n\n/* Switch Account Mode More content style */\n.agcx-accmode-more-content {\n  border-top: 1px solid #e2e8f0;\n  padding-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\nbody.dark_theme .agcx-accmode-more-content {\n  border-top-color: #2b3139;\n}\n\n.agcx-accmode-more-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.more-sec-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e2329;\n}\n\nbody.dark_theme .more-sec-title {\n  color: #eaecef;\n}\n\n.more-sec-list {\n  list-style: none;\n  padding-left: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.more-sec-list li {\n  position: relative;\n  font-size: 12px;\n  color: #707a8a;\n  padding-left: 14px;\n  line-height: 1.5;\n}\n\n.more-sec-list li::before {\n  content: \"•\";\n  position: absolute;\n  left: 0;\n  color: #848e9c;\n}\n\n.more-sec-link {\n  font-size: 12px;\n  color: #1e2329;\n  text-decoration: underline;\n  font-weight: 600;\n}\n\nbody.dark_theme .more-sec-link {\n  color: #eaecef;\n}\n\n.agcx-accmode-footer {\n  padding: 16px 20px;\n  border-top: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n\nbody.dark_theme .agcx-accmode-footer {\n  border-top-color: #2b3139;\n  background: #181a20;\n}\n\n.agcx-accmode-footer-btn {\n  width: 100%;\n  padding: 12px;\n  border-radius: 50px;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  background: #f4f5f6;\n  color: #aeaeae;\n  cursor: not-allowed;\n}\n\n.more-sec-link:hover {\n  color: #080808;\n}\n\nbody.dark_theme .agcx-accmode-footer-btn {\n  background: #2b3139;\n  color: #707a8a;\n}\n\n/* Scroll lock when modal is open */\nbody.modal-open,\nhtml.modal-open,\n.agcex-options-wrapper.modal-open {\n  overflow: hidden !important;\n  height: 100vh !important;\n}\n\n.agcx-accmode-footer-btn.active-btn {\n  background: #D1AA67;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.agcx-accmode-footer-btn.active-btn:hover {\n  background: #deac57;\n}\n\n.agcex-opt-orderbook .agcex-opt-ob-mid .agcex-text-right {\n  text-align: left;\n}\n\n\n@media screen and (max-width: 1550px) {\n\n\n  .agcex-options-wrapper {\n    margin-top: 0px;\n  }\n\n  .trade-panel-open .mid_lft_option {\n    min-width: 61.7%;\n  }\n\n}\n\n\n@media screen and (max-width: 1200px) {\n\n  .order_history_mobile_view.twomobile div {\n    border-left: 0px !important;\n  }\n\n\n  .assets_right.assets_panel_desktop.option_assetsright {\n    max-width: 100%;\n    min-width: 100%;\n  }\n\n}\n\n@media screen and (max-width: 1024px) {\n\n  body.has-sidebar-open,\n  html.has-sidebar-open {\n    overflow: hidden !important;\n    height: 100vh !important;\n  }\n\n  body.dark_theme .agcex-opt-pct-slider-track {\n    background: #525252;\n  }\n\n  .agcex-options-sidebar-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgb(255 255 255 / 20%);\n    backdrop-filter: blur(5px);\n    z-index: 9999999;\n  }\n\n  .mid_right_option {\n    position: fixed !important;\n    bottom: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    width: 100vw !important;\n    max-width: 100vw !important;\n    min-width: unset !important;\n    height: 85vh !important;\n    max-height: 85vh !important;\n    border-radius: 16px 16px 0 0 !important;\n    z-index: 99999999999 !important;\n    box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.25) !important;\n    overflow-y: auto !important;\n    animation: slideUpMobile 0.3s ease-out;\n  }\n\n  .options-recent-trades-panel {\n    width: 50%;\n  }\n\n  .mid_right_option.is-open {\n    flex-direction: column;\n  }\n\n  .agcex-options-trade-center {\n    flex: 1 1;\n    /* overflow-y: auto; */\n    display: flex;\n    flex-direction: row;\n    padding-bottom: 30px;\n  }\n\n  @keyframes slideUpMobile {\n    from {\n      transform: translateY(100%);\n    }\n\n    to {\n      transform: translateY(0);\n    }\n  }\n\n}\n\n\n\n/* Mobile Favourites Popup for Options page */\n.mobile-favourites-popup-overlay-options {\n  display: none;\n}\n\n@media screen and (max-width: 991px) {\n\n  .desktop-favourites-dropdown {\n    display: none !important;\n  }\n\n  .mobile-favourites-popup-options .orderbook-table th {\n    background: none;\n  }\n\n  /* body.light_theme .mobile-favourites-popup-options .orderbook-table th {\n    background: #ffffff;\n  } */\n\n  .mobile-favourites-popup-overlay-options {\n    display: flex !important;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgb(24 24 24 / 20%);\n    z-index: 999999999;\n    backdrop-filter: blur(5px);\n    align-items: flex-end;\n    justify-content: center;\n    animation: fadeIn 0.3s ease;\n  }\n\n  body.light_theme .mobile-favourites-popup-overlay-options {\n    background-color: rgb(255 255 255 / 20%);\n  }\n\n  .mobile-favourites-popup-options {\n    width: 100%;\n    max-height: 85vh;\n    background-color: #161616de;\n    display: flex;\n    flex-direction: column;\n    animation: slideUpMobile 0.3s ease;\n    overflow: hidden;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  body.light_theme .mobile-favourites-popup-options {\n    background-color: #ffffffc4;\n    ;\n  }\n\n  .mobile-favourites-popup-header-options {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px;\n    border-bottom: 1px solid #f0f0f01a;\n  }\n\n  body.light_theme .mobile-favourites-popup-header-options {\n    border-bottom: 1px solid #f0f0f0;\n  }\n\n  .mobile-favourites-popup-header-options h4 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #ededed;\n  }\n\n  body.light_theme .mobile-favourites-popup-header-options h4 {\n    color: #1e2329;\n  }\n\n  .mobile-favourites-close-btn-options {\n    background: transparent;\n    border: none;\n    color: #848e9c;\n    padding: 0px;\n    font-size: 24px;\n    cursor: pointer;\n    line-height: 1;\n  }\n\n  .mobile-favourites-popup-content-options {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px;\n  }\n\n  .mobile-favourites-popup-content-options .spotLists {\n    display: block !important;\n    position: static !important;\n    width: 100% !important;\n    box-shadow: none !important;\n    padding: 0 !important;\n    background: none !important;\n    backdrop-filter: inherit;\n  }\n\n  .options-scroll-arrow {\n    padding: 0px;\n    width: auto;\n    height: auto;\n  }\n\n  .options-tickers-bar {\n    gap: 5px;\n    padding: 8px 10px;\n  }\n\n}\n\n\n@media screen and (max-width: 767px) {\n\n  .options-recent-trades-container {\n    flex-direction: column;\n  }\n\n  .options-filter-row {\n    padding: 8px 6px 10px;\n  }\n\n  .options-ai-row {\n    padding: 16px 10px 8px;\n  }\n\n  .agcex-opt-modal {\n    top: inherit;\n    bottom: 0px;\n    transform: translate(-50%, -0%);\n    border-radius: 12px 12px 0px 0px;\n  }\n\n  .options-recent-trades-panel {\n    width: 100%;\n  }\n\n  .options-ticker-margin-block {\n    width: 100%;\n    border: none;\n  }\n\n  .options-ticker-margin-block .margin-col {\n    width: 100%;\n  }\n\n\n  .hdr_lft_list {\n    flex: none;\n  }\n\n}\n\n\n@media screen and (max-width: 660px) {\n\n  .options-tickers-bar {\n    flex-direction: column;\n  }\n\n  .hdr_lft_list {\n    width: 100%;\n  }\n\n  .agcex-opt-orderbook {\n    width: 100%;\n  }\n\n  .agcex-opt-orderform {\n    width: 100%;\n  }\n\n  .agcex-nsh-actions {\n    gap: 5px;\n  }\n\n  i.ri-information-fill.agcex-nsh-info {\n    display: none;\n  }\n\n  .options-ticker-margin-block {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding-left: 0px;\n    border-left: none;\n  }\n\n  .agcex-opt-group-info.right {\n    display: none;\n  }\n\n  .agcex-opt-group-info.left {\n    display: none;\n  }\n\n  .agcex-options-trade-center {\n    flex-direction: column;\n  }\n\n  .agcex-nsh-title {\n    font-size: 14px;\n  }\n\n  .agcex-nsh-tab {\n    padding: 4px 8px;\n    font-size: 12px;\n  }\n\n  .rs-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .agcx-accmode-modal {\n    width: 90%;\n  }\n\n}\n\n/* Recent Trades Cardbox view styles */\n.mobile-only-cards {\n  display: none;\n}\n\n.options-trade-card {\n  background: #fafafa;\n  border-radius: 8px;\n  padding: 12px;\n  border: 1px solid #f0f0f0;\n}\n\nbody.dark_theme .options-trade-card {\n  background: #181a20;\n  border-color: #2b3139;\n}\n\n.options-trade-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  border-bottom: 1px dashed #f0f0f0;\n  padding-bottom: 6px;\n}\n\nbody.dark_theme .options-trade-card-header {\n  border-bottom-color: #2b3139;\n}\n\n.options-trade-card-header .trade-symbol {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e2329;\n}\n\nbody.dark_theme .options-trade-card-header .trade-symbol {\n  color: #eaecef;\n}\n\n.options-trade-card-header .trade-time {\n  font-size: 11px;\n  color: #848e9c;\n}\n\n.options-trade-card-body {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.options-trade-card-body .trade-col {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.options-trade-card-body .trade-label {\n  font-size: 11px;\n  color: #848e9c;\n}\n\n.options-trade-card-body .trade-val {\n  font-size: 12px;\n  font-weight: 500;\n  color: #1e2329;\n}\n\nbody.dark_theme .options-trade-card-body .trade-val {\n  color: #eaecef;\n}\n\n@media screen and (max-width: 767px) {\n  .desktop-only-table {\n    display: none !important;\n  }\n\n  .mobile-only-cards {\n    display: flex !important;\n    flex-direction: column;\n    gap: 8px;\n    padding: 10px;\n  }\n\n  .options-ticker-symbol {\n    font-size: 12px;\n  }\n\n  .options-ticker-price {\n    font-size: 11px;\n  }\n\n  .agcex-opt-exec-type-text {\n    font-size: 12px;\n  }\n\n  .agcex-opt-input-wrap input {\n    font-size: 12px;\n  }\n\n  .agcex-opt-input-unit {\n    font-size: 12px;\n  }\n\n  .agcex-opt-submit-btn {\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n\n  .agcex-opt-input-last-price {\n    font-size: 12px;\n  }\n\n  .rs-toggle-btn {\n    padding: 7px 0;\n    font-size: 13px;\n  }\n\n  .rs-preview-btn {\n    font-size: 13px;\n    padding: 9px;\n    margin-top: 18px;\n  }\n\n  .rs-input {\n    font-size: 12px;\n  }\n\n  .rs-segment-btn {\n    font-size: 12px;\n  }\n\n  .rs-dropdown {\n    font-size: 12px;\n  }\n\n}\n\n/* Mark Slider Popup */\n.agcex-opt-mark-slider-popup {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 8px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  padding: 16px;\n  width: 280px;\n  z-index: 100;\n  border: 1px solid #e2e8f0;\n}\n\nbody.dark_theme .agcex-opt-mark-slider-popup {\n  background: #1e2329;\n  border-color: #2b3139;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);\n}\n\n.agcex-opt-mark-slider-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.agcex-opt-mark-slider-input {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 4px;\n  background: #e2e8f0;\n  border-radius: 2px;\n  outline: none;\n  margin: 12px 0;\n}\n\nbody.dark_theme .agcex-opt-mark-slider-input {\n  background: #2b3139;\n}\n\n.agcex-opt-mark-slider-input::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #fff;\n  border: 3px solid #1e2329;\n  cursor: pointer;\n}\n\nbody.dark_theme .agcex-opt-mark-slider-input::-webkit-slider-thumb {\n  background: #1e2329;\n  border-color: #eaecef;\n}\n\n.agcex-opt-mark-slider-labels {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #848e9c;\n  font-weight: 500;\n}\n\n/* Limit Price/IV Toggle Button */\n.agcex-opt-limit-toggle-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #1e2329;\n  font-size: 16px;\n  transition: all 0.2s;\n}\n\nbody.dark_theme .agcex-opt-limit-toggle-btn {\n  background: #1e2329;\n  color: #eaecef;\n}\n\n/* .agcex-opt-limit-toggle-btn:hover {\n  background: #e2e8f0;\n} */\n/* \nbody.dark_theme .agcex-opt-limit-toggle-btn:hover {\n  background: #2b3139;\n} */\n\n.agcex-opt-limit-toggle-btn i {\n  font-weight: bold;\n}\n\n/* Limit Price Input Row */\n.agcex-opt-limit-price-row {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n}\n\n/* Fix for input overflow in flex container */\n.agcex-opt-input-wrap {\n  min-width: 0;\n}\n\n.agcex-opt-input-wrap input {\n  min-width: 0;\n}\n\n.agcex-opt-limit-toggle-btn {\n  flex-shrink: 0;\n}\n\n.agcex-opt-limit-price-row .agcex-opt-input-wrap {\n  flex: 1;\n}\n\n/* —— Options page loading skeletons —— */\n@keyframes options-sk-shimmer {\n  0% {\n    background-position: 100% 0;\n  }\n\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n.options-sk__bone {\n  display: block;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #2a2e36 0%, #3a3f4a 45%, #2a2e36 90%);\n  background-size: 200% 100%;\n  animation: options-sk-shimmer 1.35s ease-in-out infinite;\n}\n\nbody.light_theme .options-sk__bone {\n  background: linear-gradient(90deg, #e8eaed 0%, #f1f5f9 45%, #e8eaed 90%);\n  background-size: 200% 100%;\n  animation: options-sk-shimmer 1.35s ease-in-out infinite;\n}\n\n.options-sk__coin {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.options-sk__line {\n  height: 12px;\n  border-radius: 4px;\n}\n\n.options-sk__line--xs {\n  width: 36px;\n}\n\n.options-sk__line--sm {\n  width: 52px;\n}\n\n.options-sk__line--md {\n  width: 72px;\n}\n\n.options-sk__line--lg {\n  width: 140px;\n}\n\n.options-sk__line--val {\n  width: 80px;\n  height: 14px;\n}\n\n.options-sk__line--price {\n  width: 88px;\n  height: 16px;\n}\n\n.options-sk__line--strike {\n  width: 56px;\n  height: 14px;\n  margin: 0 auto;\n}\n\n.options-sk__ticker {\n  pointer-events: none;\n  cursor: default;\n}\n\n.options-sk__expiry-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 0;\n}\n\n.options-sk__date-pill {\n  width: 88px;\n  height: 28px;\n  border-radius: 999px;\n  flex-shrink: 0;\n}\n\n.options-sk-chain {\n  width: 100%;\n  padding: 8px 0 16px;\n}\n\n.options-sk-chain__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  margin-bottom: 4px;\n  border-bottom: 1px solid #2b3139;\n}\n\nbody.light_theme .options-sk-chain__header {\n  border-bottom-color: #e2e8f0;\n}\n\n.options-sk-chain__row {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  min-height: 36px;\n  border-bottom: 1px solid rgba(43, 49, 57, 0.45);\n}\n\nbody.light_theme .options-sk-chain__row {\n  border-bottom-color: rgba(226, 232, 240, 0.9);\n}\n\n.options-sk-chain__side {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 6px 10px;\n  overflow: hidden;\n}\n\n.options-sk-chain__side:last-child {\n  justify-content: flex-start;\n}\n\n.options-sk-chain__strike {\n  flex: 0 0 96px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 4px;\n  border-left: 1px solid rgba(43, 49, 57, 0.45);\n  border-right: 1px solid rgba(43, 49, 57, 0.45);\n}\n\nbody.light_theme .options-sk-chain__strike {\n  border-left-color: rgba(226, 232, 240, 0.9);\n  border-right-color: rgba(226, 232, 240, 0.9);\n}\n\n.options-sk__cell {\n  width: 44px;\n  height: 12px;\n  flex-shrink: 0;\n}\n\n.options-table-container.is-loading-chain .options-global-header {\n  opacity: 0.55;\n  pointer-events: none;\n}\n\n.options-table-container.is-loading-chain .options-global-body {\n  min-height: 360px;\n}\n\n.options-global-body--skeleton {\n  display: block;\n  width: 100%;\n  min-height: 360px;\n  padding: 0 4px;\n}\n\n.options-global-body--empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 360px;\n  padding: 48px 24px;\n}\n\n.options-chain-empty-msg {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #848e9c;\n  text-align: center;\n}\n\nbody.light_theme .options-chain-empty-msg {\n  color: #848e9c;\n}\n\nbody.dark_theme .options-chain-empty-msg {\n  color: #848e9c;\n}\n\n/* Positions — exercise-style table (expiry, two-line symbol, long/short) */\n.agcex-opt-positions-table.spot_orders_table thead th {\n  color: #848e9c;\n  font-weight: 400;\n  font-size: 12px;\n  border-bottom: 1px solid #eaecef36;\n  white-space: nowrap;\n  padding: 10px 8px;\n}\n\nbody.light_theme .agcex-opt-positions-table.spot_orders_table thead th {\n  border-bottom: 1px solid #eaecef;\n}\n\n.agcex-opt-positions-table.spot_orders_table tbody td {\n  font-size: 13px;\n  vertical-align: middle;\n  border-bottom: 1px solid #f0f1f217;\n  padding: 12px 8px;\n}\n\nbody.light_theme .agcex-opt-positions-table.spot_orders_table tbody td {\n  border-bottom: 1px solid #f0f1f2;\n}\n\n.agcex-opt-positions-table.spot_orders_table tbody tr:hover {\n  background: rgba(0, 0, 0, 0.015);\n}\n\n.agcex-opt-pos-muted {\n  color: #474d57;\n  white-space: nowrap;\n}\n\n.agcex-opt-pos-symbol {\n  position: relative;\n  padding-left: 10px;\n  min-width: 120px;\n}\n\n.agcex-opt-pos-symbol::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 2px;\n  bottom: 2px;\n  width: 3px;\n  border-radius: 2px;\n  background: var(--agcex-opt-pos-accent, #848e9c);\n}\n\n.agcex-opt-pos-symbol__primary {\n  font-weight: 600;\n  line-height: 1.35;\n  color: inherit;\n}\n\n.agcex-opt-pos-symbol__secondary {\n  font-size: 12px;\n  color: #848e9c;\n  line-height: 1.35;\n}\n\nbody.dark_theme .agcex-opt-positions-table.spot_orders_table thead th {\n  color: #848e9c;\n  border-bottom-color: #2b3139;\n}\n\nbody.dark_theme .agcex-opt-positions-table.spot_orders_table tbody td {\n  border-bottom-color: #2b3139;\n}\n\nbody.dark_theme .agcex-opt-positions-table.spot_orders_table tbody tr:hover {\n  background: rgba(255, 255, 255, 0.02);\n}\n\nbody.dark_theme .agcex-opt-pos-muted {\n  color: #b7bdc6;\n}\n\nbody.dark_theme .agcex-opt-pos-symbol__secondary {\n  color: #848e9c;\n}\n\n/* Open positions PnL — beat .trade_summary_table_lft tr td color rules */\n.trade_summary_table_lft .agcex-opt-positions-table.spot_orders_table tbody td.agce-ft-pnl--profit,\n.trade_summary_table_lft .agcex-opt-positions-table.spot_orders_table tbody td.agce-ft-pnl--loss,\n.trade_summary_table_lft .so-mobileCard__row>span.agce-ft-pnl--profit,\n.trade_summary_table_lft .so-mobileCard__row>span.agce-ft-pnl--loss {\n  font-weight: 500;\n}\n\n.trade_summary_table_lft .agcex-opt-positions-table.spot_orders_table tbody td.agce-ft-pnl--profit,\n.trade_summary_table_lft .so-mobileCard__row>span.agce-ft-pnl--profit {\n  color: #0ecb81 !important;\n}\n\n.trade_summary_table_lft .agcex-opt-positions-table.spot_orders_table tbody td.agce-ft-pnl--loss,\n.trade_summary_table_lft .so-mobileCard__row>span.agce-ft-pnl--loss {\n  color: #f6465d !important;\n}\n\n/* Positions — Binance-style inline close (Close + price + qty pills) */\n.agcex-opt-close-pos-cell {\n  vertical-align: middle !important;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.agcex-opt-close-pos {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  min-width: 0;\n}\n\n.agcex-opt-close-pos__label {\n  border: none;\n  background: transparent;\n  color: #f3bb2b;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1;\n  padding: 0;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.agcex-opt-close-pos__label:hover:not(:disabled) {\n  opacity: 0.85;\n}\n\n.agcex-opt-close-pos__label:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.agcex-opt-close-pos__input {\n  width: 72px;\n  min-width: 56px;\n  border: none;\n  border-radius: 999px;\n  background: #f0f1f2;\n  color: #191919;\n  font-size: 12px;\n  line-height: 1.2;\n  padding: 6px 10px;\n  text-align: center;\n  outline: none;\n}\n\n.agcex-opt-close-pos__input:focus {\n  background: #e8eaed;\n}\n\n.agcex-opt-close-pos__input:disabled {\n  opacity: 0.6;\n}\n\nbody.dark_theme .agcex-opt-close-pos__input {\n  background: #2b3139;\n  color: #eaecef;\n}\n\nbody.dark_theme .agcex-opt-close-pos__input:focus {\n  background: #363c45;\n}\n\n.trade_summary_table_lft .spot_orders_table thead th.yellowcolor {\n  text-align: end;\n  color: #d0aa67;\n}\n\n.so-mobileCard__row .agcex-opt-close-pos {\n  width: 100%;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n.agcex-opt-ob-wrapper {\n  height: 300px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n\n.agcex-opt-trades-scroll {\n  max-height: 104px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.agcex-trade-col-wrapper {\n  width: 100%;\n}\n\n@media (min-width: 992px) {\n  .agcex-trade-col-wrapper {\n    width: 50%;\n    flex: 1;\n  }\n}\n\n@media (min-width: 992px) {\n  .mobile-trade-tabs {\n    display: none !important;\n  }\n}\n\n.mobile-trade-tabs {\n  display: flex;\n  width: 100%;\n  border-bottom: 1px solid #33363d;\n  margin-top: 12px;\n  position: relative;\n  cursor: pointer;\n}\n\n.mobile-trade-tab::before {\n  width: 30px;\n  position: absolute;\n  content: \"\";\n  height: 2px;\n  background: #fff;\n  bottom: -2px;\n  margin: 0 auto;\n  right: 0px;\n  opacity: 0;\n  left: 0px;\n}\n\nbody.light_theme .mobile-trade-tab::before {\n  background: #000;\n}\n\n.mobile-trade-tab.active::before {\n  opacity: 1;\n}\n\nbody.light_theme .mobile-trade-tabs {\n  border-bottom-color: #e2e8f0;\n}\n\n.mobile-trade-tab {\n  text-align: center;\n  padding: 10px;\n  position: relative;\n  font-weight: bold;\n  color: #848e9c;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.mobile-trade-tab.active {\n  color: #fff;\n}\n\nbody.light_theme .mobile-trade-tab.active {\n  color: #000;\n}\n\n\n@media screen and (max-width:660px) {\n\n\n  .options-tickers-scroll {\n    gap: 10px;\n    flex: auto;\n  }\n\n\n  .options-tickers-scroll .options-ticker-active-block {\n    width: 100%;\n  }\n\n  .options-tickers-scroll .options-ticker-item {\n    width: 50%;\n  }\n\n\n  .options-tickers-scroll .options-ticker-active-block .options-ticker-item {\n    width: 100%;\n  }\n\n  .options-ticker-item {\n    min-width: auto;\n  }\n\n  .options-ticker-coin-img {\n    width: 22px;\n    height: 22px;\n  }\n\n}\n\n@media screen and (max-width:480px) {\n  .options-ticker-item {\n    gap: 5px;\n    padding: 5px 5px;\n  }\n\n  .options-tickers-bar {\n    padding: 8px 7px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
